




















































































































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class OrgTree extends Vue {
  public showDialog = false;
  public dialogInfo: any = {};
  public areaData = [
    {
      id: "1",
      title: "ALCALDE",
      imagen: "",
      bajadaImagen:
        "Bajada de la imagen Bajada de la imagen Bajada de la imagen",
      description: `
        <p>Alcalde: Sr. Claudio Radonich Jiménez</p><p></p><p><b>ARTÍCULO 9º:</b> Tiene la siguiente función general:</p><p>Mantener una interacción eficiente y eficaz con la comunidad, los Servicios Públicos, Empresas Privadas y demás unidades municipales internas; estableciendo los mecanismos de seguimiento y evaluación de las acciones e iniciativas desarrolladas por medio de un sistema de organización y planificación, enfocados en el desempeño de las funciones del Alcalde.</p><p></p><p><b>ARTICULO 10º:</b> Dependerán de la Alcaldía los funcionarios que ejerzan labores de Gabinete de la Alcaldía y Relaciones Institucionales. Los cuales se definen y tendrán las siguientes funciones:</p><p></p><p>Gabinete de Alcaldía</p><p>Deberá coordinar acciones internas y externas de la Municipalidad, con la finalidad de contribuir al desempeño eficaz de las funciones que le correspondan al Alcalde.</p><p></p><p>Tendrá las siguientes funciones específicas:</p><p></p><p>1. Coordinar el trabajo en terreno del Alcalde y efectuar seguimiento de los compromisos y de las acciones derivadas de ese trabajo.</p><p></p><p>2. Monitorear y controlar el cumplimiento de las instrucciones emanadas del Alcalde.</p><p></p><p>3. Colaborar con el Alcalde en el cumplimiento adecuado de la gestión y ejecución técnica de los planes y programas de la Municipalidad.</p><p></p><p>4. Realizar un control periódico de los cronogramas y el cumplimiento de metas que determine el Alcalde.</p><p></p><p>5. Supervisar que los plazos de tramitación o procedimientos internos de gestión, que se establezcan en las distintas direcciones, se cumplan en el tiempo debido.</p><p></p><p>6. Colaborar y coordinar con las distintas unidades de la Municipalidad, en el diseño de instrumentos de gestión municipal y políticas internas de funcionamiento.</p><p></p><p>7. Requerir antecedentes a los funcionarios municipales con la finalidad de informar al Alcalde para una mejor resolución de los asuntos que se someten a su conocimiento.</p><p></p><p>8. Despachar internamente las materias administrativas, de correspondencia del Gabinete.</p><p></p><p>9. Demás atribuciones que le asigne directamente el Alcalde y en conformidad a la ley.</p><p></p><p></p><p>B) Relaciones Institucionales</p><p></p><p>Deberá ejercer las labores que se le asignen, relacionadas con las distintas actividades y programas desarrollados por la Municipalidad.</p><p>Tendrá las siguientes funciones específicas:</p><p></p><p>1. Deberá asesorar al Alcalde en las relaciones públicas que entable con las distintas autoridades, medios de comunicación social y, en general, con la ciudadanía. Lo anterior, con el objeto de mantener una adecuada y uniforme imagen del Municipio ante la comunidad local y nacional.</p><p></p><p>2. Confeccionar la agenda, programar y coordinar las actividades del Alcalde.</p><p></p><p>3. Fiscalizará el uso del logo municipal en los distintos documentos que se emitan a nombre de la Municipalidad. Asimismo, deberá autorizar y visar previamente la información que pretendan difundir interna o externamente, las distintas Direcciones Municipales y funcionarios en general, a los medios de comunicación social y, así, velar por la imagen corporativa.</p><p></p><p>4. Diseñará el contenido gráfico de los avisos, volantes, lienzos, afiches y/o pendones que utilice la Municipalidad, en las distintas actividades en organice o participe.</p><p></p><p>5. Dirigirá el protocolo en ceremonias y eventos especiales de la Municipalidad.</p><p></p><p>6. Podrá solicitar información a las distintas Unidades municipales y/o instituciones públicas, con el objeto reunir antecedentes suficientes que permitan mantener informada a la comunidad local.</p><p></p><p>7. Establecer y mantener una positiva imagen del Municipio y facilitar la comunicación e interacción de la comunidad, los servicios públicos, empresas privadas y demás unidades internas.</p><p></p><p></p><p></p><p>8. Definir las políticas comunicacionales de municipio, procesando y difundiendo la información de las actividades de todas las materias del quehacer municipal, incluyendo gabinete de alcaldía, Concejo, direcciones municipales y servicios traspasados.</p><p></p><p>9. Finalmente, realizará todas las funciones que se le encomienden y que comprometan de alguna forma la imagen de la Municipalidad de Punta Arenas velando por el estricto cumplimiento del uso de la imagen corporativa en todos los actos, documentación, actividades y/o eventos de la entidad edilicia</p> <a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a><p class="q-mt-md"> Funciones y Atribuciones que se describen en los Art. 56, 63, 64, 65, 67, 68 Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>     `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1110",
      y: "170",
      width: "180",
      height: "34"
    },
    {
      id: "2",
      title: "1ER. JUZGADO POLICÍA LOCAL",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Juez: Sr. Jaime Araneda González</p><p>Es un tribunal especial que no integra el Poder Judicial, sino que forma parte de la estructura municipal dependiendo administrativamente de la I. Municipalidad de Punta Arenas y sometido a la supervigilancia directiva, correccional y económica de la Corte de Apelaciones de Punta Arenas.</p> <br> <p>Se rige por la Ley Nº 15.231 Orgánica de los Juzgados de Policía Local y en términos generales por el procedimiento establecido en la Ley N° 18.287. El juez tiene absoluta independencia en el ejercicio de su actividad jurisdiccional.</p> <br> <p>Conce de diversas materias que son de su competencia, tales como: tránsito, derechos de los consumidores, alcoholes, urbanismo y construcción, votaciones populares y escrutinios. rentas municipales, bosque, copropiedad inmobiliaria, fraudes bancarios, seguridad privada, tenencia responsable, ordenanzas municipales, entre muchas otras.</p> <br> <p>Las conductas infraccionales y/o contravencionales permiten al tribunal establecer diversas sanciones: multas a beneficio municipal o fiscal, la que dependerá de la gravedad de la conducta y el monto establecido para la misma; suspender la licencia de conducir; informar a los diversos registros dependientes del Servicio de Registro Civil e Identificación; ordenar la clausura temporal o definitiva de un establecimiento; ordenar el remate de las especies incautadas; decretar el retiro de circulación de un vehículo en ciertos casos; retirar de un circulación del mercado un producto peligroso; entre otras medidas coercitivas.</p> <br> <a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=28104">https://www.bcn.cl/leychile/navegar?idNorma=28104</a>`,
      popUp: true,
      link: "",
      target: "_blank",
      x: "740",
      y: "232",
      width: "178",
      height: "35"
    },
    {
      id: "3",
      title: "2DO. JUZGADO POLICÍA LOCAL",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jueza: Sra. Patricia Espinoza Morales</p><p>Es un tribunal especial que no integra el Poder Judicial, sino que forma parte de la estructura municipal dependiendo administrativamente de la I. Municipalidad de Punta Arenas y sometido a la supervigilancia directiva, correccional y económica de la Corte de Apelaciones de Punta Arenas.</p><br><p>Se rige por la Ley Nº 15.231 Orgánica de los Juzgados de Policía Local y en términos generales por el procedimiento establecido en la Ley N° 18.287. El juez tiene absoluta independencia en el ejercicio de su actividad jurisdiccional.</p><br><p>Conce de diversas materias que son de su competencia, tales como: tránsito, derechos de los consumidores, alcoholes, urbanismo y construcción, votaciones populares y escrutinios. rentas municipales, bosque, copropiedad inmobiliaria, fraudes bancarios, seguridad privada, tenencia responsable, ordenanzas municipales, entre muchas otras.</p><br><p>Las conductas infraccionales y/o contravencionales permiten al tribunal establecer diversas sanciones: multas a beneficio municipal o fiscal, la que dependerá de la gravedad de la conducta y el monto establecido para la misma; suspender la licencia de conducir; informar a los diversos registros dependientes del Servicio de Registro Civil e Identificación; ordenar la clausura temporal o definitiva de un establecimiento; ordenar el remate de las especies incautadas; decretar el retiro de circulación de un vehículo en ciertos casos; retirar de un circulación del mercado un producto peligroso; entre otras medidas coercitivas.</p><br><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=28104">https://www.bcn.cl/leychile/navegar?idNorma=28104</a></p>`,
      popUp: true,
      link: "",
      target: "_blank",
      x: "920",
      y: "232",
      width: "178",
      height: "35"
    },
    {
      id: "4",
      title: "ADMINISTRACIÓN MUNICIPAL",
      imagen: "",
      bajadaImagen: "",
      description: `
        <p>Administradora Municipal: Sra. Elena Blackwood Chamorro</p><p></p><p>El Administrador Municipal, tiene las siguientes funciones generales:</p><p></p><ol ><li><p>Colaborar directamente con el Alcalde en las tareas de coordinación y gestión permanente de todas las unidades municipales.</p></li></ol><p></p><ol start="2" ><li><p>Elaboración y seguimiento del Plan Anual de Acción Municipal.</p></li></ol><p></p><ol start="3" ><li><p>Proponer la Política de Prevención de Riesgos para los funcionarios de la Municipalidad de Punta Arenas.</p></li></ol><p></p><p>Tendrá las siguientes funciones específicas:</p><p></p><ol ><li><p>Programar, ejecutar y controlar los programas, proyectos y acciones que el Alcalde le encomiende directamente.</p></li></ol><p></p><ol start="2" ><li><p>Realizar labores de coordinación de comisiones y comités de trabajo.</p></li></ol><p></p><ol start="3" ><li><p>Velar por el cumplimiento de las funciones establecidas en el reglamento de estructura y proponer los cambios que requiera.</p></li></ol><p></p><p></p><ol start="4" ><li><p>Otras funciones que le delegue el Alcalde, en conformidad con la legislación vigente y que no sea de aquellas que la Ley asigna a otras unidades.</p></li></ol><p></p><p></p><p><b>ARTÍCULO 12°:</b> El Administrador Municipal tendrá también a su cargo, las funciones de Prevención de Riesgos, que se señalan a continuación:</p><p></p><p></p><ol ><li><p>Elaborar y controlar la ejecución de los planes y programas de prevención de riesgos.</p></li></ol><p></p><ol start="2" ><li><p>Asesorar y colaborar con el Alcalde y unidades municipales en todas las materias relacionadas con el cumplimiento del Reglamento de Orden, Higiene y Seguridad.</p></li></ol><p></p><ol start="3" ><li><p>Asesorar técnicamente al Comité Paritario y a cada Dirección Municipal en materia de prevención de riesgos, seguridad y salud ocupacional.</p></li></ol><p></p><ol start="4" ><li><p>Provisionar la ropa de trabajo y elementos de protección al personal municipal, supervisando su correcta utilización.</p></li></ol><p></p><ol start="5" ><li><p>Estudiar y proponer proyectos o programas en materia de prevención de riesgos y enfermedades profesionales.</p></li></ol><p></p><ol start="6" ><li><p>Asesorar a las Unidades Técnicas en la Elaboración de Bases, con respecto a la Ley Nº 16.744 Sobre Accidentes del Trabajo y Enfermedades Profesionales, velando por el cumplimiento de esta norma.</p></li></ol><p></p><ol start="7" ><li><p>Coordinar con la Mutual respectiva, las asesorías y capacitaciones para los funcionarios municipales en materia de prevención de riesgos.</p></li></ol><p></p><ol start="8" ><li><p>Conocer, informar y registrar las denuncias de accidentes del trabajo.</p></li></ol><p></p><ol start="9" ><li><p>Realizar otras funciones que le asigne el Alcalde de conformidad con la legislación vigente y que no sea de aquellas que la ley asigna a otras unidades.</p></li></ol><p></p><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a></p>  <p class="q-mt-md">Funciones y Atribuciones que se describen en el Art. 30 Ley  N°18.695 Orgánica Constitucional de Municipalidades </p>     
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1110",
      y: "293",
      width: "178",
      height: "38"
    },
    {
      id: "5",
      title: "CONCEJO MUNICIPAL",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p><strong>Estructura Orgánica</strong></p><p>El Concejo Municipal opera regulado por la Ley Nº 18.695, Orgánica Constitucional de Municipalidades, compuesto por:</p><p><strong>Presidencia:</strong> Ejercida por el Alcalde, quien convoca, dirige las sesiones y propone los instrumentos clave de gestión (Presupuesto, PLADECO, Plan Regulador), etc.</p><p><strong>Cuerpo de Concejales:</strong> Integrado por 8 autoridades electas por votación popular.</p><p><strong>Secretaría Municipal:</strong> Unidad administrativa cuyo titular actúa como ministro de fe y secretario de actas del Concejo.</p><p><strong>Comisiones de Trabajo:</strong> Cuerpos internos (Finanzas, Infraestructura, Salud, etc.) formados por concejales para el estudio técnico de las materias. No son resolutivas; su rol es emitir informes y recomendaciones al pleno.</p><p><strong>Facultades y Atribuciones</strong></p><p>Las competencias del Concejo se agrupan en tres funciones principales ejercidas de forma colectiva:</p><ul><li><strong>Función Normativa:</strong> Capacidad para aprobar o modificar las ordenanzas municipales y los reglamentos internos que regulan la comuna y el propio funcionamiento del órgano.</li><li><strong>Función Resolutiva:</strong> Potestad para aceptar o rechazar las propuestas sobre las siguientes materias: aprobación del presupuesto anual, las modificaciones presupuestarias, la concesión de subvenciones y las licitaciones o contratos públicos que excedan los límites legales establecidos, etc.</li><li><strong>Función Fiscalizadora:</strong> Atribución para evaluar la gestión del Alcalde y de las unidades municipales. Esto faculta a los concejales para requerir informes técnicos a las distintas direcciones, evaluar la ejecución del gasto y disponer, bajo los criterios de la ley, la contratación de auditorías externas.</li></ul><p>LEY Nº 18.695, ORGÁNICA CONSTITUCIONAL DE MUNICIPALIDADES.</p><a href="https://www.bcn.cl/leychile/navegar?idNorma=251693&idVersion=" target="_blank">https://www.bcn.cl/leychile/navegar?idNorma=251693&idVersion=</a><br><p>REGLAMENTO DEL CONCEJO MUNICIPAL</p><a href="https://media.puntaarenas.cl/decretos/B/2022/953.pdf" target="_blank">https://media.puntaarenas.cl/decretos/B/2022/953.pdf</a>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1360",
      y: "248",
      width: "223",
      height: "150"
    },
    {
      id: "6",
      title: "DIRECCIÓN DE LA SECRETARÍA MUNICIPAL",
      imagen: "",
      bajadaImagen: "",
      description: `
        <p>Directora: Sra. Orieta Magna Veloso</p><p></p><p>La Secretaría Municipal tiene por objeto, otorgar el apoyo administrativo necesario para el cumplimiento eficaz de las obligaciones municipales.</p><p>Estará a cargo de un Secretario Municipal, que tiene como funciones generales las siguientes:</p><p></p><ol ><li><p>Dirigir las actividades de secretaría administrativa del Alcalde y del Concejo.</p></li></ol><p></p><ol start="2" ><li><p>Desempeñarse como Ministro de fe en todas las actuaciones municipales.</p></li></ol><p></p><ol start="3" ><li><p>Recibir, mantener y tramitar cuando corresponda las declaraciones de patrimonio e intereses establecidas en la Ley Nº 18.575.</p></li></ol><p></p><ol start="4" ><li><p>Llevar el registro municipal a que se refiere el artículo 6° de la Ley N° 19.418, sobre Juntas de Vecinos y demás Organizaciones Comunitarias.</p></li></ol><p></p><ol start="5" ><li><p>Efectuar las acciones necesarias para el funcionamiento y cumplimiento del sistema de información, reclamos y transparencia, contemplados en la Ley orgánica Constitucional de Municipalidades y en la Ley N° 20.285.</p></li></ol><p></p><ol start="6" ><li><p>Levar los registros a que se refieren la ley 20.500 sobre Asociaciones y Participación Ciudadana en la Gestión Pública; la Ley 19.862, que establece Registros de las Personas Jurídicas Receptoras de Fondos Públicos y la Ley 19.537 Copropiedad Inmobiliaria.</p></li></ol><p></p><p></p><p><b>ARTÍCULO 14°:</b> La Secretaría Municipal deberá cumplir, además, las siguientes funciones específicas:</p><p></p><ol ><li><p>Asistir y tomar acta de las Sesiones ordinarias, extraordinarias y reuniones de Comisión del Concejo, y del Consejo Comunal de Organizaciones de la Sociedad Civil.</p></li></ol><p></p><ol start="2" ><li><p>Refrendar, transcribir y comunicar las resoluciones del Alcalde, los acuerdos del Concejo, Comités y del Consejo Comunal de Organizaciones de la Sociedad Civil, manteniendo un archivo de éstos.</p></li></ol><p></p><ol start="3" ><li><p>Certificar las deudas por concepto de patentes, derechos y tasas municipales para efectos de su cobro judicial, como también deudas incobrables para que se castiguen de acuerdo al artículo 66 del D.L. 3.063.</p></li></ol><p></p><ol start="4" ><li><p>Certificar el plazo para que la Municipalidad apruebe transferencias de concesiones para construir y explotar el subsuelo.</p></li></ol><p></p><p></p><ol start="5" ><li><p>Certificar el vencimiento de los plazos legales para que el Alcalde se pronuncie respecto de los reclamos de ilegalidad.</p></li></ol><p></p><ol start="6" ><li><p>Certificar el depósito del acta constitutiva de las organizaciones comunitarias, en conformidad a la ley.</p></li></ol><p></p><ol start="7" ><li><p>Certificar las demás actuaciones municipales que establezca la ley cuando le sean solicitadas.</p></li></ol><p></p><ol start="8" ><li><p>Confeccionar los Decretos Alcaldicios, Circulares y resoluciones y otros que le solicite el Alcalde.</p></li></ol><p></p><ol start="9" ><li><p>Cumplir las funciones que le asigna la Ley Nº 19.418 sobre Juntas de Vecinos y demás organizaciones comunitarias.</p></li></ol><p></p><ol start="10" ><li><p>Mantener un constante flujo, control, archivo y conservación de toda la documentación que ingresa y egresa de la Municipalidad.</p></li></ol><p></p><ol start="11" ><li><p>Entregar al Alcalde los antecedentes necesarios de materias que deba informar al Concejo.</p></li></ol><p></p><ol start="12" ><li><p>Preparar los antecedentes de los temas de la Tabla que se tratará en las sesiones del Concejo.</p></li></ol><p></p><ol start="13" ><li><p>Llevar y mantener al día las Actas de las sesiones del Concejo, insertando los documentos que éste determine.</p></li></ol><p></p><ol start="14" ><li><p>Redactar y despachar las citaciones o invitaciones a funcionarios municipales o a personas ajenas al Municipio, que determine el Concejo.</p></li></ol><p></p><ol start="15" ><li><p>Redactar y despachar los oficios por los cuales se soliciten informes o asesorías que el Concejo estime necesario.</p></li></ol><p></p><ol start="16" ><li><p>Recibir, registrar y archivar, según corresponda, la documentación que reciba el Concejo, como también despachar la correspondencia que emane del mismo.</p></li></ol><p></p><ol start="17" ><li><p>Realizar los trámites necesarios para la constitución del Consejo Comunal de Organizaciones de la Sociedad Civil y otorgarle apoyo administrativo, según la Ley Nº 20.500.</p></li></ol><p></p><ol start="18" ><li><p>Actuar como ministro de fe para los efectos establecido en el inciso 2º del artículo 177 del Código del Trabajo.</p></li></ol><p></p><ol start="19" ><li><p>Mantener informado a los Concejales de las actividades municipales en las cuales deban participar.</p></li></ol><p></p><p></p><ol start="20" ><li><p>Cumplir con todas las funciones encomendadas en virtud de la Ley Nº 19.537 sobre Copropiedad Inmobiliaria.</p></li></ol><p></p><ol start="21" ><li><p>Mantener actualizado el sistema de INTRANET de la Municipalidad y en general, todos los sistemas computacionales que se implementen con el objeto de mejorar la gestión municipal interna.</p></li></ol><p></p><ol start="22" ><li><p>Ingreso de correspondencia a la Municipalidad. Adicionalmente, deberá recibir y despachar la documentación que sea enviada por los distintos departamentos de la Municipalidad.</p></li></ol><p></p><ol start="23" ><li><p>Mantener actualizado el sitio electrónico habilitado por la municipalidad para efectos de la aplicación de la transparencia activa contemplada en la Ley N° 20.285.</p></li></ol><p></p><ol start="24" ><li><p>Dar respuesta a la solicitud de información efectuada por cualquier persona en el marco de la ley de Transparencia.</p></li></ol><p></p><ol start="25" ><li><p>Tramitar y dar respuesta a los reclamos efectuados por cualquier persona ante el municipio.</p></li></ol><p></p><ol start="26" ><li><p>Mantener a disposición de la comunidad, la documentación que se indica en el art. 98 de la Ley Orgánica de Municipalidades.</p></li></ol><p></p><ol start="27" ><li><p>Coordinar con todas las unidades municipales las acciones necesarias para dar cumplimiento a lo establecido en la Ley N° 20.285 sobre Acceso a la Información Pública, dentro de los plazos establecidos.</p></li></ol><p></p><ol start="28" ><li><p>Mantener, coordinar y ejecutar las actuaciones necesarias para el correcto funcionamiento y cumplimiento del sistema de Información y transparencia pasiva, contemplados en la Ley Orgánica Constitucional de Municipalidades y en la Ley Nº 20.285 de Acceso a la Información Pública, debiendo elaborar los formatos tipo de respuestas que deberán entregar las distintas Unidades y visarlas para la firma del Alcalde.</p></li></ol><p></p><ol start="29" ><li><p>Realizar todas las acciones necesarias para que el municipio de cumplimiento a la Ley de Transparencia, velando principalmente por los plazos establecidos en ella.</p></li></ol><p></p><ol start="30" ><li><p>Llevar estadísticas actualizadas de todas las materias de su competencia e informarlas periódicamente a la SECPLAN.</p></li></ol><p></p><ol start="31" ><li><p>Realizar otras funciones que le asigne el Alcalde de conformidad a la legislación vigente y que no sea de aquellas que la ley asigna a otras unidades.</p></li></ol><p></p><p></p><p><b>ARTÍCULO 15°:</b> Para el ejercicio de sus atribuciones la Secretaría Municipal, tendrá a su cargo el Departamento de Personas Jurídicas.</p><p></p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a><p class="q-pt-md">Funciones y Atribuciones que se describen en el  Art. 20  Ley  N°18.695 Orgánica Constitucional de Municipalidades
</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "79",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "7",
      title: "DEPARTAMENTO DE PERSONAS JURÍDICAS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento: Sin Destinación</p><p></p><p>Tendrá las siguientes funciones específicas:</p><p></p><ol ><li><p>Cumplir las funciones que le asigna la Ley Nº 19.418 sobre Juntas de Vecinos y demás organizaciones comunitarias.</p></li></ol><p></p><ol start="2" ><li><p>Revisar la legalidad de los estatutos de las organizaciones comunitarias.</p></li></ol><p></p><ol start="3" ><li><p>Recibir y tramitar los depósitos de estatutos y de sus modificaciones de las asociaciones y fundaciones que se constituyan o tengan domicilio en la comuna.</p></li></ol><p></p><ol start="4" ><li><p>Confeccionar los Certificados de Vigencia que soliciten las organizaciones comunitarias.</p></li></ol><p></p><ol start="5" ><li><p>Entregar la información al Registro Nacional de Personas Jurídicas sin Fines de Lucro, conforme lo establezca su reglamento respectivo.</p></li></ol><p></p><ol start="6" ><li><p>Cumplir las demás funciones que el Secretario Municipal le encomiende, en el ámbito de su competencia.</p></li></ol><p></p><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a></p><p></p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "79",
      y: "502",
      width: "80",
      height: "48"
    },
    {
      id: "8",
      title: "DIRECCIÓN DE SECRETARÍA COMUNAL DE PLANIFICACIÓN",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Director: Sr. Nicolás Pérez-Montt Arana</p><p></p><p>La Secretaría Comunal de Planificación desempeñará funciones de asesoría del Alcalde y del Concejo, en materias de estudios y evaluación, propias de las competencias de ambos órganos municipales.</p><p></p><p>La Secretaría Comunal de Planificación tendrá las siguientes funciones y atribuciones:</p><p></p><ol ><li><p>Servir de secretaría técnica permanente del Alcalde y del Concejo en la formulación de la estrategia municipal, como asimismo de las políticas, planes, programas y proyectos de desarrollo de la comuna.</p></li></ol><p></p><ol start="2" ><li><p>Asesorar al Alcalde en la elaboración de los proyectos de Plan Comunal de Desarrollo y de Presupuesto Municipal.</p></li></ol><p></p><ol start="3" ><li><p>Evaluar el cumplimiento de los planes, programas, proyectos, inversiones y el presupuesto municipal e informar sobre estas materias al Concejo, a lo menos semestralmente.</p></li></ol><p></p><ol start="4" ><li><p>Efectuar análisis y evaluaciones permanentes de la situación de desarrollo de la Comuna, con énfasis en los aspectos sociales y territoriales.</p></li></ol><p></p><ol start="5" ><li><p>Elaborar las bases generales y específicas, según corresponda, para losllamados a licitación, previo informe de la unidad competente y de acuerdo al procedimiento respectivo.</p></li></ol><p></p><ol start="6" ><li><p>Fomentar vinculaciones de carácter técnico con los servicios públicos y con el sector privado de la Comuna.</p></li></ol><p></p><ol start="7" ><li><p>Recopilar y mantener la información comunal y regional actualizada, atingente a sus funciones.</p></li></ol><p></p><ol start="8" ><li><p>Proponer la actualización del Plan de Desarrollo Comunal y proponer las modificaciones necesarias a los planes, programas y estrategias municipales.</p></li></ol><p></p><ol start="9" ><li><p>Mantener informadas a las unidades municipales respecto de las fechas de postulación, fuentes de financiamiento y en general, de los fondos de inversión que puedan servir al desarrollo local.</p></li></ol><p></p><ol start="10" ><li><p>Llevar un Registro de los proyectos de inversión comunal -elaborados por el Municipio- en ejecución y por ejecutarse, recopilando la información desde las unidades municipales y servicios públicos.</p></li></ol><p></p><ol start="11" ><li><p>Informar al Alcalde y a las Unidades Municipales que correspondan de aquellas iniciativas de inversión que obtengan financiamiento.</p></li></ol><p></p><ol start="12" ><li><p>Coordinar y colaborar con la Corporación Municipal en la presentación de proyectos de inversión.</p></li></ol><p></p><ol start="13" ><li><p>Recopilar y preparar los antecedentes necesarios para la Cuenta Pública.</p></li></ol><p></p><ol start="14" ><li><p>Proponer al Alcalde sistemas de concesiones para bienes y/o servicios municipales.</p></li></ol><p></p><ol start="15" ><li><p>Mantener actualizada la información estadística estratégica de la Comuna y de la Municipalidad, proporcionando la información necesaria a las Unidades Municipales.</p></li></ol><p></p><ol start="16" ><li><p>Realizar otras funciones que le asigne el Alcalde de conformidad con la legislación vigente y que no sea de aquellas que la Ley asigna a otras unidades.</p></li></ol><p></p><p></p><p><b>ARTÍCULO 17º:</b> Para el ejercicio de sus atribuciones la Secretaría Comunal de Planificación, tendrá a su cargo el Departamento de Planificación, Proyectos y Licitaciones.</p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a><p class="q-pt-md">Funciones y Atribuciones que se describen en el  Art. 21  Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "168",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "9",
      title:
        "DEPARTAMENTO DE PLANIFICACIÓN ESTRATÉGICA, PROYECTOS Y LICITACIONES",
      imagen: "",
      bajadaImagen: "",
      description: `
     <p>Estarán a su cargo la Sección de Planificación Estratégica, la Sección de Proyectos y la Sección de Licitaciones.</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "168",
      y: "573",
      width: "80",
      height: "49"
    },
    {
      id: "10",
      title: "SECCIÓN DE PLANIFICACIÓN ESTRATÉGICA",
      imagen: "",
      bajadaImagen: "",
      description: `
     <p></p><p></p><ol ><li><p>Elaborar y proponer el Presupuesto Municipal en los plazos establecidos en la Ley, requiriendo de las Unidades Municipales y específicamente de Administración y Finanzas toda la información.</p></li></ol><p></p><ol start="2" ><li><p>Evaluar el cumplimiento del presupuesto municipal, informando a lo menos semestralmente al Alcalde y al Concejo.</p></li></ol><p></p><ol start="3" ><li><p>Realizar seguimiento y supervisión de la ejecución presupuestaria de los Programas municipales.</p></li></ol><p></p><ol start="4" ><li><p>Preparar informes al Alcalde sobre el estado del Presupuesto Municipal, entregando asesoría respecto de este instrumento.</p></li></ol><p></p><ol start="5" ><li><p>Elaborar la planificación técnica y presupuestaria de los programas o iniciativas para el mejoramiento continuo de la gestión municipal, fortalecimiento de las capacidades institucionales, acreditación de la calidad de sus procesos, y de sus resultados, así como para la instalación efectiva de una cultura organizacional de mejoramiento continuo.</p></li></ol><p></p><ol start="6" ><li><p>Coordinar las iniciativas que contribuyan ampliar las capacidades de la gestión municipal, a través del desarrollo o mejoramiento de las competencias existentes u otras que sean idóneas y efectivas para este propósito.</p></li></ol><p></p><ol start="7" ><li><p>Promover las acciones de cultura organizacional de mejoramiento continuo en el municipio, tales como seminarios, talleres u otros idóneos y efectivos para este propósito.</p></li></ol><p></p><ol start="8" ><li><p>Proponer y evaluar los indicadores de gestión que sean pertinentes para el control, seguimiento y evaluación de las iniciativas y/o programas de responsabilidad de la SECPLAN.</p></li></ol><p></p><ol start="9" ><li><p>Llevar registro de los convenios celebrados con distintas organizaciones e instituciones del sector público y privado, en relación a la ejecución de planes, programas y proyectos de adelanto comunal.</p></li></ol><p></p><ol start="10" ><li><p>Mantener y actualizar una base de datos, sistema de información geográfico (SIG), con información social, económica, demográfica, etc., de la comuna y elaborar con esta información, estudios, análisis de diagnóstico y caracterización del territorio. Así como también para la disponibilidad de los datos necesarios, para la interconexión hacia los centros de mando, control y gestión de la comuna.</p></li></ol><p></p><ol start="11" ><li><p>Generación y actualización permanente de cartografía temática, de acuerdo a los lineamientos estratégicos definidos por la administración.</p></li></ol><p></p><ol start="12" ><li><p>Georreferenciar y geolocalizar, toda la información municipal en coordinación con todas las direcciones municipales, organizaciones comunitarias, funcionales y/o no funcionales, instituciones del estado, empresas privadas entre otros.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "75",
      y: "653",
      width: "82",
      height: "49"
    },
    {
      id: "11",
      title: "SECCIÓN DE PROYECTOS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <ol ><li><p>Análisis de información producto del levantamiento de datos, que sirvan como insumo para la creación de proyectos, programas, estudios entre otros.</p></li></ol><p></p><ol start="2" ><li><p>Identificar fuentes de financiamiento público y privado de carácter nacional e internacional para la ejecución de proyectos específicos.</p></li></ol><p></p><ol start="3" ><li><p>Apoyar en las distintas etapas técnicas (Diseño, formulación, postulación, contratación, seguimiento y evaluación), del desarrollo de proyectos de viviendas sociales en coordinación con las demás unidades municipales.</p></li></ol><p></p><ol start="4" ><li><p>Proporcionar el material técnico necesario para los llamados a propuestas para la ejecución de proyectos derivados del plan de inversiones.</p></li></ol><p></p><ol start="5" ><li><p>Elaborar, proponer, programar y ejercer la coordinación general del Plan de inversiones municipales, en coordinación con las distintas direcciones municipales, considerando entre otros la evaluación de costos, cronogramas de ejecución y seguimiento físico de los proyectos de inversión.</p></li></ol><p></p><ol start="6" ><li><p>Realizar estudios, preparar y formular iniciativas de inversión de interés comunal, para ser presentadas a fuentes de financiamiento externas.</p></li></ol><p></p><ol start="7" ><li><p>Ingresar, mantener y actualizar en el Banco Integrado de Proyectos (BIP) del Sistema Nacional de Inversiones (SNI); en la plataforma SUBDERE en línea o en cualquier otro Sistema de seguimiento de proyectos, las iniciativas de inversión municipal, de acuerdo a los procedimientos establecidos por el respectivo organismo</p></li></ol><p></p><ol start="8" ><li><p>Elaborar los convenios mandatos y convenios de transferencia para la ejecución de las iniciativas de inversión, los que deberán ser visados por la Dirección de Asesoría Jurídica y Control. Asimismo, deberá llevar un Registro actualizado de éstos.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "168",
      y: "653",
      width: "82",
      height: "49"
    },
    {
      id: "12",
      title: "SECCIÓN DE LICITACIONES",
      imagen: "",
      bajadaImagen: "",
      description: `
        <ol ><li><p>Preparar en Noviembre de cada año, la programación de licitaciones con financiamiento municipal del año siguiente, entregando esta información a las Direcciones Municipales involucradas.</p></li></ol><p></p><ol start="2" ><li><p>Confeccionar las bases administrativas generales y especiales, y colaborar con las demás direcciones municipales en la elaboración de las bases o especificaciones técnicas de licitación, para la contratación de bienes y servicios.</p></li></ol><p></p><ol start="3" ><li><p>Validar las bases de licitación y gestionar en conjunto con las unidades técnicas la aprobación y publicación de las respectivas bases para la contratación de bienes y servicios.</p></li></ol><p></p><ol start="4" ><li><p>Apoyar la elaboración y/o revisión de las actas de evaluación formuladas por la comisión evaluadora designada para tal efecto.</p></li></ol><p></p><p></p><p></p><p><b>ARTÍCULO 17 Bis</b>: Adscrito a esta Dirección estará el Asesor Urbanista, quien tendrá las siguientes funciones generales:</p><p>1. Asesorar al Alcalde y al Concejo en la promoción del Desarrollo Urbano en conformidad a la situación geográfica de la comuna.</p><p>2. Estudiar y elaborar el Plan Regulador Comunal, y mantenerlo actualizado, promoviendo las modificaciones que sean necesarias y preparar el Plan de inversiones en infraestructura de movilidad y espacio público y los planos de detalle y planes seccionales en su caso.</p><p>3. Informar técnicamente las proposiciones sobre planificación urbana intercomunal, formuladas al Municipio por la Secretaría Regional Ministerial de Vivienda y Urbanismo.</p><p></p><p><b>ARTÍCULO 17 TER:</b> Adicionalmente, el Asesor Urbanista tendrá las siguientes funciones específicas:</p><ol ><li><p>Coordinar, fomentar y relacionarse con todos aquellos organismos públicos y privados en materia de desarrollo y planificación urbana y territorial.</p></li></ol><p></p><ol start="2" ><li><p>Recopilar y mantener la información comunal y regional atingente a sus funciones.</p></li></ol><p></p><ol start="3" ><li><p>Preparar ordenanzas especiales para regular aquellos aspectos que dicen relación con el espacio público, ya sea urbano o rural.</p></li></ol><p></p><ol start="4" ><li><p>Proponer al Alcalde y al Concejo la regulación del subsuelo público de la comuna, que se encuentre bajo la administración de la Municipalidad.</p></li></ol><p></p><ol start="5" ><li><p>Estudiar proyectos de construcciones específicos que ocupen espacios en la vía pública, procurando la conservación y armonía arquitectónica de la comuna.</p></li></ol><p></p><ol start="6" ><li><p>Asesorar a las unidades municipales, en materias de Instrumentos de Planificación y Ordenamiento Territorial.</p></li></ol><p></p><ol start="7" ><li><p>Asesorar y colaborar con la Dirección de Obras Municipales en aquellas obras y proyectos que considere necesaria su intervención, con la finalidad de mantener una adecuada imagen urbanística de la ciudad.</p></li></ol><p></p><ol start="8" ><li><p>Proponer a la Dirección medidas relacionadas con la vialidad urbana.</p></li></ol><p></p><ol start="9" ><li><p>Proponer y elaborar las bases de datos comunales necesarias para el adecuado desempeño de las funciones propias.</p></li></ol><p></p><ol start="10" ><li><p>Certificar las materias de su competencia.</p></li></ol><p></p><ol start="11" ><li><p>Ejecutar todas las atribuciones que se le encomienden en conformidad a la Ley General de Urbanismo y Construcciones.</p></li></ol><p></p><ol start="12" ><li><p>Realizar las funciones que el Director le encomiende.</p></li></ol><p></p><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a></p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "258",
      y: "653",
      width: "82",
      height: "49"
    },
    {
      id: "13",
      title: "DIRECCIÓN DE CONTROL",
      imagen: "",
      bajadaImagen: "",
      description: `
        <p>Directora: Sra. Rita Vrsalovic Cabezas</p><p>La Dirección de Control será la encargada de ejercer el control de la legalidad de los actos administrativos, financieros, contables y de gestión que emanen de la Municipalidad, con la finalidad de resguardar el principio de probidad administrativa y resguardar el patrimonio municipal.</p><p></p><p>Tendrá las siguientes funciones generales:</p><p></p><ol ><li><p>Realizar la auditoría operativa interna de la municipalidad, con el objeto de fiscalizar la legalidad de su actuación.</p></li></ol><p></p><ol start="2" ><li><p>Controlar la ejecución financiera y presupuestaria municipal.</p></li></ol><p></p><ol start="3" ><li><p>Representar al alcalde los actos municipales que estime ilegales, informando de ello al concejo, para cuyo objeto tendrá acceso a toda la información disponible. Dicha representación deberá efectuarse dentro de los diez días siguientes a aquel en que la unidad de control haya tomado conocimiento de los actos. Si el alcalde no tomare medidas administrativas con el objeto de enmendar el acto representado, la unidad de control deberá remitir dicha información a la Contraloría General de la República.</p></li></ol><p></p><ol start="4" ><li><p>Colaborar directamente con el concejo para el ejercicio de sus funciones fiscalizadoras. Para estos efectos, emitirá un informe trimestral acerca del estado de avance del ejercicio programático presupuestario; asimismo, deberá informar, también trimestralmente, sobre el estado de cumplimiento de los pagos por concepto de cotizaciones previsionales de los funcionarios municipales y de los trabajadores que se desempeñan en servicios incorporados a la gestión municipal, administrados directamente por la municipalidad o a través de corporaciones municipales, de los aportes que la municipalidad debe efectuar al Fondo Común Municipal, y del estado de cumplimiento de los pagos por concepto de asignaciones de perfeccionamiento docente. En todo caso, deberá dar respuesta por escrito a las consultas o peticiones de informes que le formule un concejal.</p></li></ol><p></p><ol start="5" ><li><p>Asesorar al concejo en la definición y evaluación de la auditoría externa que aquél puede requerir en virtud de la Ley Nº 18.695.</p></li></ol><p></p><ol start="6" ><li><p>Realizar, con la periodicidad que determine el Reglamento señalado en el artículo 92 de la Ley Nº 18.695, una presentación en sesión de comisión del concejo, destinada a que sus miembros puedan formular consultas referidas al cumplimiento de las funciones que le competen.</p></li></ol><p></p><p></p><p><b>ARTÍCULO 19º:</b> La Dirección de Control tendrá, además, las siguientes funciones específicas:</p><p></p><ol ><li><p>Evaluar dentro de sus atribuciones legales el funcionamiento administrativo del Municipio y proponer el mejoramiento de su organización o métodos cuando corresponda.</p></li></ol><p></p><ol start="2" ><li><p>Estudiar y proponer el uso de nuevas técnicas operativas y administrativas.</p></li></ol><p></p><ol start="3" ><li><p>Analizar las instrucciones y reglamentos, recomendando cuando proceda, su elaboración o actualización.</p></li></ol><p></p><ol start="4" ><li><p>Asesorar en la puesta en marcha de cualquier nueva función o procedimiento que se establezca.</p></li></ol><p></p><ol start="5" ><li><p>Prestar asesoría al Alcalde y servir de órgano de consulta para el resto de las unidades municipales en lo relativo a sus funciones.</p></li></ol><p></p><ol start="6" ><li><p>Conocer todo acto administrativo municipal que tenga contenido patrimonial.</p></li><li><p>Supervisar periódicamente los registros e inventarios de los bienes físicos municipales.</p></li></ol><p></p><ol start="8" ><li><p>Controlar el cumplimiento y recomendar la actualización de los convenios y contratos que comprometan la responsabilidad y/o bienes municipales.</p></li></ol><p></p><ol start="9" ><li><p>Verificar el cumplimiento de los programas y el destino de las inversiones municipales.</p></li></ol><p></p><ol start="10" ><li><p>Auditar los informes y estados financieros que la Municipalidad presente interna o externamente con relación a su exactitud, oportunidad, veracidad y utilidad.</p></li></ol><p></p><ol start="11" ><li><p>Fiscalizar el destino de los fondos entregados mediante subvenciones municipales.</p></li></ol><p></p><ol start="12" ><li><p>Representar al Concejo los déficits que advierta en el presupuesto municipal.</p></li></ol><p></p><ol start="13" ><li><p>Realizar y proponer manuales de procedimientos de gestión interna y auditoria, por propia iniciativa o por encargo del Alcalde.</p></li></ol><p></p><ol start="14" ><li><p>Fiscalizar a las Corporaciones, Fundaciones y Asociaciones Municipales, respecto del uso y destino de sus recursos, pudiendo requerir toda la información necesaria para tal efecto.</p></li></ol><p></p><ol start="15" ><li><p>Efectuar controles permanentes y sistemáticos a las unidades operativas y administrativas.</p></li></ol><p></p><ol start="16" ><li><p>Realizar exámenes oportunos a las operaciones económicas y financieras procediendo a representar situaciones que no se enmarquen en el ámbito de la legalidad vigente, y otros que disponga la Dirección.</p></li></ol><p></p><ol start="17" ><li><p>Llevar estadísticas actualizadas de todas las materias de su competencia e informarlas periódicamente a la SECPLAN.</p></li></ol><p></p><ol start="18" ><li><p>Cumplir con las demás funciones que la ley, el Alcalde le encomienden, dentro del ámbito de su competencia.</p></li></ol><p></p><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a></p> <p class="q-pt-md">Funciones y Atribuciones que se describen en el  Art. 29  Ley  N°18.695 Orgánica Constitucional de Municipalidades.</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "255",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "14",
      title: "DIRECCIÓN DE ASESORÍA JURÍDICA",
      imagen: "",
      bajadaImagen: "",
      description: `
    <p></p><p>Directora: Sra. Claudia Casas Karelovic (subrogrante)</p><p></p><p>La Dirección de Asesoría Jurídica es una unidad encargada de informar conforme a Derecho, los asuntos que le encomiende el Alcalde y deberá procurar defender judicialmente los intereses de la Municipalidad. Dependerá directamente del Alcalde y tendrá las siguientes funciones generales:</p><p></p><ol ><li><p>Prestar apoyo en materias legales al Alcalde y al Concejo Municipal.</p></li></ol><p></p><ol start="2" ><li><p>Informar en Derecho todos los asuntos legales que las distintas unidades municipales le planteen.</p></li></ol><p></p><ol start="3" ><li><p>Iniciar y asumir la defensa, a requerimiento del Alcalde en todos aquellos juicios en que la Municipalidad sea parte o tenga interés.</p></li></ol><p></p><ol start="4" ><li><p>Efectuar, cuando lo ordene el Alcalde, las investigaciones y sumarios administrativos, sin perjuicio que también puedan ser realizados por funcionarios de cualquier unidad municipal, bajo la supervigilancia de asesoría jurídica.</p></li></ol><p></p><ol start="5" ><li><p>Orientar periódicamente a las unidades municipales y comisiones de trabajo respecto de las disposiciones legales y reglamentarias.</p></li></ol><p></p><ol start="6" ><li><p>Formar y mantener al día los títulos de los bienes raíces municipales.</p></li></ol><p></p><ol start="6" ><li><p>Prestar asesoría o defensa de la comunidad cuando sea procedente y el Alcalde así lo requiera.</p></li></ol><p></p><p><b>ARTÍCULO 21º:</b> La Dirección de Asesoría Jurídica tendrá las siguientes funciones específicas:</p><p></p><ol ><li><p>Informar al Alcalde las deficiencias jurídicas que observe en los procesos o procedimientos municipales y proponer alternativas de solución.</p></li></ol><p></p><ol start="2" ><li><p>Realizar las gestiones necesarias para las expropiaciones que corresponda efectuar al Municipio.</p></li></ol><p></p><ol start="3" ><li><p>Elaborar y/o revisar todos los contratos, convenios y mandatos que suscriba el Municipio.</p></li></ol><p></p><ol start="4" ><li><p>Llevar estadísticas actualizadas de todas las materias de su competencia e informarlas periódicamente a la SECPLAN.</p></li></ol><p></p><ol start="5" ><li><p>Realizar otras funciones que le asigne el Alcalde de conformidad con la legislación vigente y que no sea de aquellas que la ley asigna a otras unidades.</p></li></ol><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a> <p class="q-pt-md">Funciones y Atribuciones que se describen en el  Art. 28  Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "345",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "15",
      title: "DEPARTAMENTO DE GESTIÓN Y COBRANZA JUDICIAL",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento: Sr. Cristian Navarro Kamann</p><p></p><p>Tendrá las siguientes funciones específicas:</p><p></p><ol ><li><p>Iniciar y asumir la defensa de toda clase de acciones legales, de cualquier naturaleza que sean en que la municipalidad sea parte o tenga interés.</p></li></ol><ol start="2" ><li><p>Asumir la asesoría o defensa de la comunidad, cuando se procedente y el Alcalde así lo determine.</p></li></ol><p></p><ol start="3" ><li><p>Informar, por requerimiento judicial, los reclamos de ilegalidad, recursos de protección y amparo económico que se presenten en contra del municipio o de sus unidades o funcionarios, por actuaciones u omisiones municipales y asumir la correspondiente defensa judicial.</p></li></ol><p></p><ol start="4" ><li><p>Informar y recomendar las transacciones para precaver litigios eventuales o dar término a pleitos pendientes en contra de la Municipalidad.</p></li></ol><p></p><ol start="5" ><li><p>Efectuar la cobranza judicial de impuestos, derechos, concesiones, arriendos y otros cuando proceda.</p></li></ol><p></p><ol start="6" ><li><p>Efectuar la cobranza judicial de contribuyentes de la municipalidad que se encuentran en estado de morosidad de pago de impuestos y derechos municipales.</p></li></ol><p></p><ol start="7" ><li><p>Cumplir con las demás funciones que el Director jurídico le encomiende.</p></li></ol><p></p><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a></p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "345",
      y: "502",
      width: "80",
      height: "48"
    },
    {
      id: "16",
      title: "DIRECCIÓN DE OBRAS MUNICIAPLES",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Director: Sr. Alex Saldivia Carrasco</p>      <p>La Dirección de Obras Municipales será la encargada de velar por el cumplimiento de las disposiciones legales en las materias relacionadas con la urbanización o edificación.</p><p>Para el cumplimiento de sus funciones contará con los Departamentos de Edificación y Catastro, y Departamento de Construcción.</p><p></p><p>Tendrá las siguientes funciones generales:</p><p></p><ol ><li><p>Velar por el cumplimiento de las disposiciones de La Ley General de Urbanismo y Construcciones, del Plan Regulador Comunal y de las ordenanzas correspondientes.</p></li><li><p>Fiscalizar las obras en uso, a fin de verificar el cumplimiento de las disposiciones legales y técnicas que las rijan.</p></li><li><p>Aplicar normas ambientales relacionadas con obras de construcción y urbanización.</p></li><li><p>Confeccionar y mantener actualizado el catastro de las obras de urbanización y edificación realizadas en la comuna.</p></li><li><p>Ejecutar medidas relacionadas con la vialidad urbana y rural, y pronunciarse sobre los informes de mitigación de impacto vial presentados en la comuna a petición de la Secretaria Ministerial de Transportes y Telecomunicaciones o de la Dirección de Tránsito y Transporte Público.</p></li><li><p>Dirigir las construcciones que sean de responsabilidad municipal, sean ejecutadas directamente o a través de terceros.</p></li><li><p>En general, aplicar las normas legales sobre construcción y urbanización en la Comuna.</p></li><li><p>Asesorar en la definición de las especificaciones técnicas y/o proyectos a las unidades correspondiente, cuando se trate de obras menores.</p></li></ol><p></p><p></p><p><b>ARTÍCULO 24º: </b>Para el cumplimiento de sus funciones, la Dirección de Obras Municipales, contara con los siguientes Departamentos:</p><p></p><ol type="A" ><li><p>Edificación y Catastro</p></li><li><p>Construcciones.</p></li></ol><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a><p class="q-pt-md">Funciones y Atribuciones que se describen en el Art. 24  Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "432",
      y: "443",
      width: "83",
      height: "48"
    },
    {
      id: "17",
      title: "DEPARTAMENTO DE EDIFICACIÓN Y CATASTRO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Tendrá las siguientes funciones específicas:</p><ol ><li><p>Dar aprobación a las subdivisiones y modificaciones de deslindes de predios en las áreas urbanas, de extensión urbana, o rurales en caso de la aplicación del artículo 55 de la Ley General de Urbanismo y Construcciones.</p></li><li><p>Dar aprobación a los anteproyectos y proyectos de obras de urbanización y edificación, y otorgar los permisos correspondientes, previa verificación de que éstos cumplen con los aspectos a realizar de a acuerdo a la Ley General de Urbanismo y Construcciones.</p></li></ol><p></p><ol start="3" ><li><p>Fiscalizar la ejecución de las obras señaladas en punto anterior hasta el momento de su recepción</p></li><li><p>Recibirse de las obras y autorizar su uso, previa verificación de que éstas cumplen con los aspectos a revisar de acuerdo a la Ley General de Urbanismo y Construcciones.</p></li><li><p>Coordinar y mantener relación con todos aquellos organismos públicos y privados en materias de urbanismo y construcción.</p></li><li><p>Proponer la asignación de nombres a nuevas vías, conjuntos habitacionales y espacios públicos. (NOOO).</p></li><li><p>Asesorar al Alcalde y al Concejo en la priorización de obras de pavimentación de aceras y calzadas de la Comuna.</p></li><li><p>Velar por el cumplimiento de las normas legales y reglamentarias, denunciar las infracciones al Juzgado de Policía Local y solicitar clausuras, cierres o demoliciones cuando proceda.</p></li><li><p>Confeccionar y mantener actualizado el Catastro de las Obras de Urbanización y Edificación realizadas en la comuna.</p></li><li><p>Elaborar y mantener actualizado el Catastro de las Edificaciones Patrimoniales de la comuna.</p></li><li><p>Otorgar los certificados de líneas, de números, afecto a utilidad pública, informes previos, y otros.</p></li><li><p>Podrá solicitar información a las distintas direcciones, para el correcto cumplimiento en la confección de catastros.</p></li><li><p>Otorgar, controlar y fiscalizar los permisos de ocupación de Bien Nacional de Uso Público en coordinación con otras unidades municipales.</p></li><li><p>Realizar otras funciones que le asigne el Alcalde de conformidad con la legislación vigente y que no sea de aquellas que la Ley asigna a otras unidades.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "385",
      y: "594",
      width: "83",
      height: "48"
    },
    {
      id: "18",
      title: "DEPARTAMENTO DE CONSTRUCCIONES",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento (s) Sr. Alejandro Barrientos Muñoz</p><p>Tendrá las siguientes funciones y atribuciones específicas:</p><ol ><li><p>Actuar como Unidad Técnica e Inspección Técnica de Obras a objeto de fiscalizar la ejecución de las Obras que la Municipalidad efectué, ya sea de manera directa o por encargo de terceros.</p></li><li><p>Revisar los antecedentes y legajo de antecedentes antes de licitar, y enviar a la unidad formuladora, las observaciones encontradas, para su corrección y reenvío a la Dirección de Obras.</p></li><li><p>Llevar la programación financiera de las construcciones en que actúe como unidad técnica e inspección técnica de obras.</p></li><li><p>Realizar el seguimiento de las diferentes garantías de obras en ejecución, así como el seguimiento en la calidad de obras, y las observaciones de sus usuarios, de las construcciones en que actúe como unidad técnica e inspección técnica de obras.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "480",
      y: "594",
      width: "80",
      height: "48"
    },
    {
      id: "19",
      title: "DIRECCIÓN DE MEDIO AMBIENTE, ASEO Y ORNATO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Directora: Sr. Christián Muñoz</p><p></p><p>La Dirección de Medio Ambiente, Aseo y Ornato será la encargada de velar por el correcto mantenimiento del aseo de las vías públicas, parques, plazas, jardines y, en general, de los bienes nacionales de uso público existentes en la comuna; así como la construcción, conservación y administración de las áreas verdes, promoviendo y contribuyendo al desarrollo sustentable de la comuna.</p><p></p><p>Para el cumplimiento de sus funciones la Dirección tendrá las siguientes funciones generales:</p><p></p><ol ><li><p>Ejecutar directamente o a través de terceros, el aseo de las vías públicas, parques, plazas, jardines, y en general, de los bienes nacionales de uso público de la comuna o bajo la administración del Municipio.</p></li></ol><p></p><ol start="2" ><li><p>Ejecutar directamente o través de terceros, el servicio de recolección y extracción de basura, el tratamiento y disposición final de los desechos domiciliarios.</p></li></ol><p></p><ol start="3" ><li><p>Construir, mantener, reparar, conservar y administrar áreas verdes de la comuna, ya sea directamente o a través de terceros.</p></li></ol><p></p><ol start="4" ><li><p>Colaborar con la Dirección de Administración y Finanzas en el cálculo del derecho de aseo domiciliario, de acuerdo con la Ley de Rentas Municipales y la Ordenanza respectiva.</p></li></ol><p></p><ol start="5" ><li><p>Especificar y supervisar la construcción y mantención de las áreas verdes en la comuna de acuerdo al Plan de Desarrollo Comunal.</p></li></ol><p></p><ol start="6" ><li><p>Elaborar y evaluar planes de acción tendientes a optimizar los servicios de aseo y ornato en la comuna.</p></li></ol><p></p><ol start="7" ><li><p>Llevar el catastro actualizado de las plazas y áreas verdes de la comuna.</p></li></ol><p></p><ol start="8" ><li><p>Supervisar y fiscalizar el cumplimiento de los contratos que en materia de aseo y ornato mantiene el Municipio e informar su cumplimiento al Alcalde.</p></li></ol><p></p><ol start="9" ><li><p>Visar las facturas de pago de los servicios de aseo y ornato contratados a través de licitación pública.</p></li></ol><p></p><ol start="10" ><li><p>Estudiar y proponer proyectos de forestación o repoblamiento arbóreo de áreas verdes de la comuna, en conjunto con otras unidades municipales u otras instituciones públicas y privadas.</p></li></ol><p></p><ol start="11" ><li><p>Regular, asesorar y supervisar todos los proyectos de Arborización y Áreas Verdes Públicas ejecutadas por loteadores, urbanizadores, concesionarios y/o vecinos que realicen en la comuna.</p></li></ol><p></p><ol start="12" ><li><p>Aprobar y colaborar con su infraestructura y asesoría técnica en la protección y defensa de las áreas verdes y especies vegetales de la comuna.</p></li></ol><p></p><ol start="13" ><li><p>Supervisar las autorizaciones otorgadas por el Municipio para las podas realizadas por las empresas de utilidad pública, con el objeto de mantener libres sus líneas.</p></li></ol><p></p><ol start="14" ><li><p>Administrar el sistema de alumbrado público de responsabilidad municipal.</p></li></ol><p></p><ol start="15" ><li><p>Diseñar proyectos nuevos de iluminación en espacios público para su ejecución.</p></li></ol><p></p><ol start="16" ><li><p>Mantener actualizado el catastro de luminarias y similares existentes en la comuna.</p></li></ol><p></p><p>17. Realizar otras funciones que le asigne el Alcalde de conformidad con la legislación vigente y que no sea de aquellas que la ley asigna a otras unidades.</p><p></p><p></p><p><b>ARTÍCULO 28º:</b> Para el cumplimiento de sus funciones contará con el Departamento de Medio Ambiente y Tenencia Responsable de Mascotas.</p> <a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a> <p class="q-pt-md">Funciones y Atribuciones que se describen en el  Art. 25   Ley  N°18.695 Orgánica Constitucional de Municipalidades.</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "523",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "20",
      title: "DEPARTAMENTO DE AMBIENTE Y TENENCIA RESPONSABLE DE MASCOTAS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento: Sr. Christian Muñoz Oyarzo</p><p></p><p>Tendrá las siguientes funciones específicas:</p><p></p><ol ><li><p>Proponer y ejecutar medidas tendientes a materializar acciones y programas relacionados con el medio ambiente.</p></li></ol><p></p><ol start="2" ><li><p>Aplicar las normas ambientales a ejecutarse en la comuna que sean de su competencia.</p></li></ol><p></p><ol start="3" ><li><p>Ordenar, procesar y actualizar permanentemente la información concerniente a los contratos de esta Dirección, por medio de estadísticas e informes respecto de su vigencia, fechas de término, prorrogas, garantías, multas y comportamiento de las empresas.</p></li></ol><p></p><ol start="4" ><li><p>Elaborar y/o proponer modificaciones a Ordenanzas y Reglamentos, relacionados con la Dirección de Medio Ambiente, Aseo y Ornato.</p></li></ol><p></p><ol start="5" ><li><p>Velar por el cumplimiento de las normas de la Ley Nº 19.300 sobre Bases Generales del Medio Ambiente y sus modificaciones.</p></li></ol><p></p><ol start="6" ><li><p>Elaborar el anteproyecto de Ordenanza Ambiental.</p></li></ol><p></p><ol start="7" ><li><p>Realizar estudios específicos a solicitud del Director de Medio Ambiente, Aseo y Ornato.</p></li></ol><p></p><ol start="8" ><li><p>Revisar las Facturas de los contratos dependientes de este Departamento.</p></li></ol><p></p><ol start="9" ><li><p>Emitir informes técnicos relativos a materias medio ambientales, de aseo y ornato.</p></li></ol><p></p><ol start="10" ><li><p>Asesorar en materia de medio ambiente a los proyectos que desarrolle el Municipio.</p></li></ol><p></p><ol start="11" ><li><p>Velar por el cumplimiento de las disposiciones legales y reglamentarias relacionadas con materias medio ambientales.</p></li></ol><p></p><ol start="12" ><li><p>Diseñar, elaborar y ejecutar estudios y proyectos sobre problemas sanitario-ambientales locales.</p></li></ol><p></p><ol start="13" ><li><p>Coordinar acciones en materias medio ambientales y tenencia responsable de mascotas, con otros Servicios y organismos públicos y privados.</p></li></ol><p></p><ol start="14" ><li><p>Informar al Juez competente los incumplimientos de los planes de descontaminación, prevención, emergencia o manejo ambiental que infrinjan la Ley de Bases Generales del Medio Ambiente.</p></li></ol><p></p><ol start="15" ><li><p>Recibir y gestionar denuncias por incumplimiento de normas ambientales e informarlas al organismo fiscalizador y Ministerio correspondiente.</p></li></ol><p></p><ol start="16" ><li><p>Actuar como contraparte técnica en los estudios y declaraciones de impacto ambiental, si corresponde y, en general, responder los requerimientos que realice formalmente el Servicio de Evaluación Ambiental.</p></li></ol><p></p><ol start="17" ><li><p>Planificar actividades de difusión y educación, referentes a la protección del medio ambiente comunal y tenencia responsable de mascotas.</p></li></ol><p></p><ol start="18" ><li><p>Verificar denuncias sobre tenencia responsable de mascotas, en conformidad a la Ley Nº 21.020.</p></li></ol><p></p><ol start="19" ><li><p>Administrar el Centro de Rescate Canino Municipal, ya sea por sí mismo o través de un tercero.</p></li></ol><p></p><ol start="20" ><li><p>Apoyar a la comunidad en la implementación de la ley Nº 21.020.</p></li></ol><p></p><ol start="21" ><li><p>Realizar operativos veterinarios caninos gratuitos a la comunidad (Implementación de microchip, vacunas antirrábicas y/o desparasitación).</p></li></ol><p></p><ol start="22" ><li><p>Efectuar programas de esterilización felina y canina para la comunidad, a través de terceros.</p></li></ol><p></p><ol start="23" ><li><p>Efectuar directamente la implementación de microchip a caninos y felinos de la comuna.</p></li></ol><p></p><ol start="24" ><li><p>Llevar estadísticas actualizadas de todas las materias de su competencia e informarlas periódicamente a la SECPLAN.</p></li></ol><p></p><ol start="25" ><li><p>Realizar otras funciones que le asigne el Alcalde de conformidad con la legislación vigente y que no sea de aquellas que la ley asigna a otras unidades.</p></li></ol><p></p><p><a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a></p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "523",
      y: "500",
      width: "80",
      height: "48"
    },
    {
      id: "21",
      title: "DIRECCIÓN DE BIENESTAR",
      imagen: "",
      bajadaImagen: "",
      description: `
        <p>Directora: Sra. Claudia Delich</p><p></p><p>La Dirección de Bienestar tendrá las siguientes funciones generales:</p><p></p><ol ><li><p>Proponer y ejecutar acciones de bienestar para el personal municipal.</p></li></ol><p></p><ol start="2" ><li><p>Actuar como Secretaría Ejecutiva o integrante, en lo referente a Comité de Bienestar, Comité de Selección de Personal, Junta Calificadora, Comité Técnico de Metas y cuando la ley y reglamentos así lo determinen.</p></li></ol><p></p><ol start="3" ><li><p>Administrar los recursos financieros del Servicio de Bienestar</p></li></ol><p></p><p><b>ARTÍCULO 50º:</b> Para el cumplimiento de sus funciones la Dirección de Bienestar, tendrá las siguientes funciones específicas:</p><p></p><p></p><ol ><li><p>Percibir los recursos y efectuar los pagos correspondientes, conforme al reglamento, acuerdos del Comité y compromisos contraídos por las personas afiliadas, con instituciones en convenio.</p></li></ol><p></p><ol start="2" ><li><p>Mantener un sistema administrativo, contable y financiero, con la información de cada persona afiliada, y los beneficios entregados.</p></li></ol><p></p><ol start="3" ><li><p>Informar trimestralmente al Comité de Bienestar un Estado de Avance de la Ejecución Presupuestaria y un resumen de las prestaciones entregadas.</p></li></ol><p></p><ol start="4" ><li><p>Mantener coordinación permanente con las distintas unidades del municipio y con instituciones externas de la organización, cuyas funciones se relacionen con beneficios del Servicio de Bienestar.</p></li></ol><p></p><ol start="5" ><li><p>Promover la celebración de convenios con instituciones y empresas orientadas a generar beneficios para las personas afiliadas.</p></li></ol><p></p><ol start="6" ><li><p>Elaborar, implementar y evaluar programas y proyectos específicos orientados al bienestar de las personas, y gestionar la entrega de los beneficios solicitados.</p></li></ol><p></p><ol start="7" ><li><p>Ejecutar los acuerdos adoptados por el Comité de Bienestar.</p></li></ol><p></p><ol start="8" ><li><p>Desarrollar actividades que permitan conocer las inquietudes, aspiraciones y necesidades de las personas afiliadas de tal manera que se motive con su participación a la satisfacción de sus propias necesidades.</p></li></ol><p></p><ol start="9" ><li><p>Proponer al Comité la Planificación Anual de Actividades de Bienestar.</p></li></ol><p></p><ol start="10" ><li><p>Proponer al Comité el Presupuesto Anual del Servicio de Bienestar.</p></li></ol><p></p><ol start="11" ><li><p>Presentar al Comité el Balance Anual del Ingreso y Administración de los recursos y de las prestaciones entregadas.</p></li></ol><p></p><ol start="12" ><li><p>Presentar al Comité el Informe de Gestión Anual.</p></li></ol><p></p><ol start="13" ><li><p>Elaborar Informes para Transparencia, SUBDERE y otros organismos.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "630",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "22",
      title: "DIRECCIÓN DE ADMINISTRACIÓN Y FINANZAS",
      imagen: "",
      bajadaImagen: "",
      description: `
           <p >Director: Sr. Claudio Oyarzo Paredes</p>      <p ><span >La Direcci&oacute;n de Administraci&oacute;n y Finanzas tiene las siguientes funciones generales:</span></p><ol>    <li >        <p >Asesorar al Alcalde en la administraci&oacute;n financiera de la entidad.</p>    </li></ol><ol start="2">    <li >        <p >Recaudar, pagar y rendir los fondos recibidos en administraci&oacute;n.</p>    </li></ol><ol start="3">    <li >        <p >Efectuar la eficiente y oportuna provisi&oacute;n de insumos, materiales, muebles y &uacute;tiles necesarios para el desarrollo de las actividades de todas las unidades municipales.</p>    </li></ol><p ><span size="3" ><strong>ART&Iacute;CULO 33&ordm;:</strong></span><span > La Direcci&oacute;n de Administraci&oacute;n y Finanzas tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p><ol>    <li >        <p >Estudiar, calcular, proponer y regular la percepci&oacute;n de cualquier tipo de ingresos municipales.</p>    </li></ol><ol start="2">    <li >        <p >Visar los Decretos de Pago.</p>    </li></ol><ol start="3">    <li >        <p >Colaborar con la Secretar&iacute;a Comunal de Planificaci&oacute;n en la elaboraci&oacute;n del presupuesto municipal.</p>    </li></ol><ol start="4">    <li >        <p >Llevar la contabilidad municipal en conformidad con las normas de la Contabilidad Nacional y con las instrucciones que la Contralor&iacute;a General de la Rep&uacute;blica imparta al respecto.</p>    </li></ol><ol start="5">    <li >        <p >Efectuar los pagos municipales, manejar las cuentas bancarias respectivas y rendir cuenta a la Contralor&iacute;a General de la Rep&uacute;blica.</p>    </li></ol><ol start="6">    <li >        <p >Controlar la gesti&oacute;n financiera de las empresas municipales.</p>    </li></ol><ol start="7">    <li >        <p >Recaudar y percibir los ingresos fiscales y municipales que correspondan.</p>    </li></ol><ol start="8">    <li >        <p >Podr&aacute; invertir los saldos estacionales de Caja, seg&uacute;n el estado de las finanzas municipales y en conformidad a la Ley.</p>    </li></ol><ol start="9">    <li >        <p >Informar trimestralmente al Concejo sobre el detalle mensual de los pasivos acumulados desglosando las cuentas por pagar por el municipio y las corporaciones municipales. Al efecto, dichas corporaciones deber&aacute;n informar a esta unidad acerca de su situaci&oacute;n financiera, desglosando las cuentas por pagar.&nbsp;</p>    </li></ol><ol start="10">    <li >        <p >Mantener un registro mensual sobre el desglose de los gastos del Municipio, que ser&aacute; de p&uacute;blico conocimiento y estar&aacute; disponible en la p&aacute;gina web.</p>    </li></ol><ol start="11">    <li >        <p >Remitir a la Subsecretar&iacute;a de Desarrollo Regional y Administrativo del Ministerio del Interior, en el formato y por los medios que &eacute;sta determine y proporcione, los antecedentes a que se refieren los n&uacute;meros 9 y 10 precedentes. Dicha Subsecretar&iacute;a deber&aacute; informar a la Contralor&iacute;a General de la Rep&uacute;blica, a lo menos semestralmente, los antecedentes se&ntilde;alados en el n&uacute;mero 9 antes referido.</p>    </li></ol><ol start="12">    <li >        <p >Llevar estad&iacute;sticas actualizadas de todas las materias de su competencia e informarlas peri&oacute;dicamente a la SECPLAN.</p>    </li></ol><ol start="13">    <li >        <p >Realizar otras funciones que le asigne el Alcalde de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la Ley asigna a otras unidades.</p>    </li></ol><p ><span size="3" ><strong>ART&Iacute;CULO 34&ordm;:</strong></span><span > Para el cumplimiento de sus funciones, la Direcci&oacute;n de Administraci&oacute;n y Finanzas, contar&aacute; con los siguientes Departamentos.</span></p><ol type="A">    <li >        <p >Tesorer&iacute;a</p>    </li>    <li >        <p >Rentas y Patentes Municipales</p>    </li>    <li >        <p >Contabilidad y presupuesto</p>    </li>    <li >        <p >Abastecimiento</p>    </li></ol> <a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a> <p class="q-pt-md">Funciones y Atribuciones que se describen en el    Art. 27 Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "850",
      y: "443",
      width: "80",
      height: "48"
    },
    {
      id: "23",
      title: "DEPARTAMENTO DE TESORERÍA",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p >Jefe de departamento: Sr. Rubén Avendaño Melo</p><ol>    <li >        <p >Recaudar, registrar y depositar los tributos, otros ingresos municipales y los ingresos recibidos en administraci&oacute;n.</p>    </li></ol><ol start="2">    <li >        <p >Conservar y custodiar los fondos recaudados, las especies valoradas y dem&aacute;s valores municipales.</p>    </li></ol><ol start="3">    <li >        <p >Actuar como martillero en los remates municipales.</p>    </li></ol><ol start="4">    <li >        <p >Recibir y custodiar toda clase de instrumentos de garant&iacute;a.</p>    </li></ol><ol start="5">    <li >        <p >Celebrar convenios de pago por impuestos y derechos municipales morosos.</p>    </li></ol><ol start="6">    <li >        <p >Elaboraci&oacute;n y seguimiento del Programa de Caja de la Municipalidad.</p>    </li></ol><ol start="7">    <li >        <p >Asesorar a la DAF en materia de Inversi&oacute;n de Mercado de Capitales.</p>    </li></ol><p ><span ><strong> Secci&oacute;n Ingresos y Cobranzas</strong></span></p><ol>    <li >        <p >Recaudar, registrar y depositar todos los impuestos, derechos y fondos en administraci&oacute;n.</p>    </li></ol><ol start="2">    <li >        <p >Efectuar la rendici&oacute;n diaria de la caja municipal, remitiendo esta informaci&oacute;n al Departamento de Contabilidad.</p>    </li></ol><ol start="3">    <li >        <p >Efectuar directamente o a trav&eacute;s de terceros la cobranza administrativa de Impuestos y derechos municipales morosos.</p>    </li></ol><ol start="4">    <li >        <p >Proponer la aplicaci&oacute;n de planes o programas de cobranzas.</p>    </li></ol><ol start="5">    <li >        <p >Mantener actualizada la cartera de deudores e informar trimestralmente al Alcalde.</p>    </li></ol><ol start="6">    <li >        <p >Confeccionar la liquidaci&oacute;n de los cr&eacute;ditos municipales morosos y remitirlos a la Secretar&iacute;a Municipal para su certificaci&oacute;n, previa visaci&oacute;n de la Tesorera Municipal.</p>    </li></ol><ol start="7">    <li >        <p >Refrendar e imputar a los &iacute;tems presupuestarios que correspondan, todo ingreso municipal.</p>    </li></ol><p ><span size="3" ><strong> Secci&oacute;n Egresos&nbsp;</strong></span></p><ol>    <li >        <p >Efectuar el pago y registro de las obligaciones municipales y de los fondos recibidos en administraci&oacute;n.</p>    </li></ol><ol start="2">    <li >        <p >Enviar diariamente el detalle de los egresos al Departamento de Contabilidad.</p>    </li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "718",
      y: "519",
      width: "80",
      height: "48"
    },
    {
      id: "24",
      title: "SECCIÓN INGRESOS Y COBRANZAS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <ol ><li><p>Recaudar, registrar y depositar todos los impuestos, derechos y fondos en administración.</p></li></ol><p></p><ol start="2" ><li><p>Efectuar la rendición diaria de la caja municipal, remitiendo esta información al Departamento de Contabilidad.</p></li></ol><p></p><ol start="3" ><li><p>Efectuar directamente o a través de terceros la cobranza administrativa de Impuestos y derechos municipales morosos.</p></li></ol><p></p><ol start="4" ><li><p>Proponer la aplicación de planes o programas de cobranzas.</p></li></ol><p></p><ol start="5" ><li><p>Mantener actualizada la cartera de deudores e informar trimestralmente al Alcalde.</p></li></ol><p></p><ol start="6" ><li><p>Confeccionar la liquidación de los créditos municipales morosos y remitirlos a la Secretaría Municipal para su certificación, previa visación de la Tesorera Municipal.</p></li></ol><p></p><ol start="7" ><li><p>Refrendar e imputar a los ítems presupuestarios que correspondan, todo ingreso municipal.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "668",
      y: "615",
      width: "80",
      height: "48"
    },
    {
      id: "25",
      title: "SECCIÓN EGRESOS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <ol ><li><p>Efectuar el pago y registro de las obligaciones municipales y de los fondos recibidos en administración.</p></li></ol><p></p><ol start="2" ><li><p>Enviar diariamente el detalle de los egresos al Departamento de Contabilidad.</p></li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "765",
      y: "615",
      width: "80",
      height: "48"
    },
    {
      id: "26",
      title: "DEPARTAMENTO DE RENTAS Y PATENTES MUNICIPALES",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p >Jefe de departamento: Sr. Ricardo Barría Bustamante</p><ol>    <li >        <p >Estudiar, calcular, proponer y regular la percepci&oacute;n de cualquier tipo de ingreso municipal.</p>    </li></ol><ol start="2">    <li >        <p >Tramitar el otorgamiento de permisos municipales.</p>    </li></ol><ol start="3">    <li >        <p >Tramitaci&oacute;n de las solicitudes que ingresen a la Municipalidad para la realizaci&oacute;n de eventos en espacios p&uacute;blicos o bienes municipales, requeridos por las distintas unidades municipales, personas naturales o jur&iacute;dicas de derecho privado.</p>    </li></ol><ol start="4">    <li >        <p >Emitir los boletines de ingreso para el pago de derechos y patentes municipales.</p>    </li>    <li >        <p >Mantener el registro actualizado de los derechos de aseo domiciliario.</p>    </li></ol><ol start="6">    <li >        <p >Tramitar las solicitudes de otorgamiento, traslado, transferencia, renovaci&oacute;n, y caducidad, seg&uacute;n corresponda, de las patentes municipales.&nbsp;</p>    </li></ol><ol start="7">    <li >        <p >Mantener actualizado el Registro de Patentes municipales as&iacute; como el correspondiente a la propaganda de la comuna.</p>    </li></ol><ol start="8">    <li >        <p >Certificar las distribuciones de capital propio tributario y las rebajas de inversiones de conformidad a la Ley de Rentas Municipales.</p>    </li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "806",
      y: "519",
      width: "80",
      height: "48"
    },

    {
      id: "27",
      title: "DEPARTAMENTO DE CONTABILIDAD Y PRESUPUESTO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p >Jefe de departamento: Sra. Cynthia Vidal Haro</p><ol>    <li >        <p >Llevar la Contabilidad Gubernamental de conformidad a las normas legales vigentes.</p>    </li></ol><ol start="2">    <li >        <p >Confeccionar los decretos de pago y egresos, tanto de fondos municipales como de fondos recibidos en administraci&oacute;n.</p>    </li></ol><ol start="3">    <li >        <p >Mantener actualizado el valor del activo y pasivo de la Municipalidad.</p>    </li></ol><ol start="4">    <li >        <p >Mantener las cuentas bancarias y conciliaciones bancarias actualizadas de conformidad a las normas legales vigentes.&nbsp;</p>    </li></ol><ol start="5">    <li >        <p >Mantener el registro de la documentaci&oacute;n que de origen a obligaciones de car&aacute;cter financiero de la Municipalidad.</p>    </li></ol><ol start="6">    <li >        <p >Presentar rendiciones de cuentas a las entidades por fondos recibidos en administraci&oacute;n.</p>    </li></ol><ol start="7">    <li >        <p >Exigir las rendiciones de cuentas por fondos entregados a funcionarios municipales para el cumplimiento de atribuciones propias de su cargo.</p>    </li></ol><ol start="8">    <li >        <p >Preparar informes, balances y estados de situaci&oacute;n financiera municipal y de fondos de terceros.</p>    </li></ol><ol start="9">    <li >        <p >Refrendar e imputar a los &iacute;tems presupuestarios que correspondan, todo egreso municipal.</p>    </li></ol><ol start="10">    <li >        <p >Preparar y proponer modificaciones al presupuesto municipal.</p>    </li></ol><ol start="11">    <li >        <p >Analizar la ejecuci&oacute;n del presupuesto municipal.<br>&nbsp;</p>    </li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "895",
      y: "519",
      width: "80",
      height: "48"
    },
    {
      id: "28",
      title: "DEPARTAMENTO DE ABASTECIMIENTO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento: Sr. Antonio Vargas Villarroel</p> <p>El Departamento de Abastecimiento tendrá a su cargo la Sección de Compras y Sección Bodega e Inventario.</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "980",
      y: "519",
      width: "80",
      height: "48"
    },
    {
      id: "29",
      title: "SECCIÓN COMPRAS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <ol>    <li >        <p >Gestionar la adquisici&oacute;n de bienes y servicios para el funcionamiento interno de la Municipalidad.</p>    </li></ol><ol start="2">    <li >        <p >Preparar y ejecutar el Plan Anual de Compras, informando oportunamente de las desviaciones a la planificaci&oacute;n.</p>    </li></ol><ol start="3">    <li >        <p >Confeccionar las especificaciones t&eacute;cnicas para la adquisici&oacute;n de bienes y servicios, para la gesti&oacute;n interna de la Municipalidad.</p>    </li></ol><ol start="4">    <li >        <p >Elaborar y proponer normas espec&iacute;ficas para las adquisiciones de bienes y servicios.</p>    </li></ol><ol start="5">    <li >        <p >Confeccionar las &oacute;rdenes de compra para la adquisici&oacute;n de materiales, bienes, servicios e insumos.</p>    </li></ol><ol start="6">    <li >        <p >Administrar los Contratos de Suministros generados para el funcionamiento de la Municipalidad.</p>    </li></ol><ol start="7">    <li >        <p >Efectuar an&aacute;lisis de los gastos, proponiendo medidas de eficiencia.</p>    </li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "929",
      y: "599",
      width: "80",
      height: "48"
    },
    {
      id: "30",
      title: "SECCIÓN BODEGA E INVENTARIO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <ol>    <li >        <p >Recibir, registrar, almacenar y distribuir racionalmente los recursos materiales provenientes de las adquisiciones.</p>    </li></ol><ol start="2">    <li >        <p >Proponer medidas de eficiencia en el uso de los insumos de bodega.</p>    </li></ol><ol start="3">    <li >        <p >Mantener actualizados los registros de existencia de insumos en bodega y proponer un mejor aprovechamiento de &eacute;stos.&nbsp;</p>    </li></ol><ol start="4">    <li >        <p >Determinar estado m&aacute;ximo y m&iacute;nimo de bienes en bodega para el normal y eficiente funcionamiento de las dependencias municipales.</p>    </li></ol><ol start="5">    <li >        <p >Aplicar medidas atingentes a la conservaci&oacute;n de los materiales almacenados en bodega.</p>    </li></ol><ol start="6">    <li >        <p >Mantener actualizado los registros de inventarios valorados de los bienes municipales, realizando controles peri&oacute;dicos de los mismos.</p>    </li></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1025",
      y: "599",
      width: "80",
      height: "48"
    },
    {
      id: "31",
      title: "DIRECCIÓN DE GESTIÓN DEL RIESGO DE DESASTRES",
      imagen: "",
      bajadaImagen: "",
      description: `
        Directora: Srta. Sonia Vargas
        <ol> <p>1. Prestar apoyo al alcalde en todas las materias referentes al Sistema Nacional de Prevenci&oacute;n y Respuesta ante Desastres.</p> <p>2. Elaborar el Plan Comunal para la Reducci&oacute;n del Riesgo de Desastres y el Plan Comunal de Emergencia, en conformidad con lo dispuesto en la ley que establece el Sistema Nacional de Prevenci&oacute;n y Respuesta ante Desastres y su reglamento.</p> <p>3. Confeccionar los informes en aquellas materias de su competencia, referidas a los art&iacute;culos 28 y 32 de la ley 21.364, cuando las unidades se&ntilde;aladas en dichos art&iacute;culos soliciten su pronunciamiento.</p> <p>4. Aportar al funcionario que designe el Director Regional del Servicio Nacional de Prevenci&oacute;n y Respuesta ante Desastres, la informaci&oacute;n referente a su comuna para la elaboraci&oacute;n del mapa de riesgo que contempla la ley que establece el Sistema Nacional de Prevenci&oacute;n y Respuesta ante Desastres.</p> <p>5. Coordinar con la Direcci&oacute;n Regional del Servicio Nacional de Prevenci&oacute;n y Respuesta ante Desastres, y con los organismos o entidades p&uacute;blicas correspondientes, en el marco de sus competencias, las acciones en materia de Gesti&oacute;n del Riesgo de Desastres de la comuna.</p> <p>6. Proponer reglamentos y ordenanzas que permitan normar el quehacer y el funcionamiento de la Direcci&oacute;n y sus dependencias en el cumplimiento de sus objetivos.</p> <p>7. Apoyar operativamente los requerimientos de la comunidad en el &aacute;mbito del quehacer municipal.</p> <p>8. Coordinar y proponer al Alcalde turnos de los funcionarios de la Direcci&oacute;n, que permitan el relevo de estos para que ejerzan labores ante una emergencia, desastre o cat&aacute;strofe.</p> <p>9. Llevar estad&iacute;sticas actualizadas de todas las materias de su competencia e informarlas peri&oacute;dicamente a la SECPLAN.</p> <p>10. Realizar otras funciones que le asigne el Alcalde de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la Ley asigna a otras unidades.</p></ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1079",
      y: "443",
      width: "88",
      height: "49"
    },
    {
      id: "33",
      title: "DIRECCIÓN DE DESARROLLO COMUNITARIO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Directora: Sra. Jessica Castillo Ruíz</p>
      <p ><span >La Direcci&oacute;n de Desarrollo Comunitario tiene como objetivo asesorar al Alcalde y al Concejo, en las acciones de desarrollo social, comunitario y cultural de la comuna, con la finalidad de que cada uno de sus habitantes logre una mejor calidad de vida.</span></p>
<p ><span size="3" >La Direcci&oacute;n de Desarrollo Comunitario deber&aacute; cumplir con las siguientes funciones generales:&nbsp;</span></p>
<ol>
    <li >
        <p >Asesorar al alcalde y, tambi&eacute;n, al Concejo en la promoci&oacute;n del desarrollo comunitario.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Prestar asesor&iacute;a t&eacute;cnica a las organizaciones comunitarias, fomentar su desarrollo y legalizaci&oacute;n, y promover su efectiva participaci&oacute;n en el municipio.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Proponer y ejecutar, dentro de su &aacute;mbito y cuando corresponda, medidas tendientes a materializar acciones relacionadas con salud p&uacute;blica, educaci&oacute;n y cultura, deporte y recreaci&oacute;n.</p>
    </li>
</ol>
<p ><span size="3" ><strong>ART&Iacute;CULO 39&ordm;:</strong></span><span > La Direcci&oacute;n de Desarrollo Comunitario tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p >Detectar y evaluar necesidades de la comunidad y encauzar su soluci&oacute;n, dentro de las funciones propias del Municipio, a trav&eacute;s de la propuesta de pol&iacute;ticas o planes sociales.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Participar en la aplicaci&oacute;n de planes, programas y proyectos que sean de competencia de la unidad, y que deban desarrollarse en coordinaci&oacute;n con otras entidades p&uacute;blicas y privadas.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Proponer y ejecutar planes de capacitaci&oacute;n para dirigentes comunitarios, respecto de materias que digan relaci&oacute;n con pol&iacute;ticas sociales de gobierno, pol&iacute;ticas locales u otras tem&aacute;ticas de inter&eacute;s contingente que favorezcan su plena participaci&oacute;n.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Coordinar el desarrollo de acciones sociales con otras unidades municipales, con instituciones de voluntariado e instituciones p&uacute;blicas y privadas.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Velar por la aplicaci&oacute;n de criterios de equidad en la entrega de beneficios asistenciales para personas carentes de recursos.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Proponer y ejecutar acciones para la promoci&oacute;n de la igualdad de oportunidades entre hombres y mujeres.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Dise&ntilde;ar e implementar planes, programas y proyectos destinados al establecimiento de estrategias comunales para personas con discapacidad, para la vejez y envejecimiento.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Elaborar y ejecutar planes, programas y proyectos para el establecimiento de estrategias comunales sobre infancia y juventud.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Elaborar y ejecutar pol&iacute;ticas locales, vinculadas con poblaci&oacute;n migrante y pueblos originarios.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Informar y orientar a la comunidad sobre los distintos beneficios de car&aacute;cter social y comunitario disponibles y los requisitos exigidos para acceder a ellos.</p>
    </li>
    <li >
        <p >Dise&ntilde;ar e implementar planes, programas y proyectos destinados al fomento del deporte y la recreaci&oacute;n y la vida sana.</p>
    </li>
</ol>
<ol start="12">
    <li >
        <p >Dise&ntilde;ar e implementar planes, programas y proyectos para la promoci&oacute;n de la cultura y las artes.</p>
    </li>
</ol>
<ol start="13">
    <li >
        <p >Realizar otras funciones que le asigne el Alcalde, de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la Ley asigna a otras unidades.&nbsp;</p>
    </li>
</ol>
<p ><span size="3" ><strong>ART&Iacute;CULO 40&ordm;:&nbsp;</strong></span><span >Para el cumplimiento de sus fines, la Direcci&oacute;n de Desarrollo Comunitario, contar&aacute; con los siguientes Departamentos:</span></p>
<ol type="A">
    <li >
        <p >Gesti&oacute;n Administrativa y de Proyectos</p>
    </li>
    <li >
        <p >Desarrollo Social</p>
    </li>
    <li >
        <p >Desarrollo Local Comunitario</p>
    </li>
    <li >
        <p >Servicios Focalizados</p>
    </li>
</ol>
<a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a>
<p class="q-pt-md">Funciones y Atribuciones que se describen en el  Art. 22  Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1332",
      y: "443",
      width: "80",
      height: "48"
    },

    {
      id: "34",
      title: "DEPARTAMENTO DE GESTIÓN ADMINISTRATIVA Y DE PROYECTOS",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >El Departamento de Gesti&oacute;n Administrativa y de Proyectos, tendr&aacute; como objetivo servir de apoyo a la Direcci&oacute;n, ejecutando funciones que aseguren el cumplimiento de los objetivos estrat&eacute;gicos.</span></p>
<p ><span >Para tales efectos debe cumplir las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Entregar las directrices a los distintos Departamentos de la Direcci&oacute;n para la elaboraci&oacute;n de planificaci&oacute;n anual de actividades, plan anual de compras y elaboraci&oacute;n de presupuesto, realizando la consolidaci&oacute;n de antecedentes para su correspondiente validaci&oacute;n.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Supervisar, fiscalizar y consolidar todo tipo de informaci&oacute;n presupuestaria, de planificaci&oacute;n, resultados de gesti&oacute;n, procedimientos, entre otros, que permitan entregar a la Direcci&oacute;n una visi&oacute;n global del funcionamiento.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Administrar los recursos humanos de la Direcci&oacute;n, preocup&aacute;ndose de la planificaci&oacute;n eficiente y el perfeccionamiento de &eacute;stos con el objeto de brindar una atenci&oacute;n de calidad.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Procurar el orden administrativo, generando y/o instruyendo la elaboraci&oacute;n de procedimientos internos y el uso de formatos tipo para la gesti&oacute;n de documentaci&oacute;n tanto interna como externa.&nbsp;</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Verificar y gestionar ante quien corresponda, el mejoramiento de las condiciones de seguridad y funcionalidad de los lugares de trabajo, para los funcionarios.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Efectuar seguimiento a metas del programa de mejoramiento de la gesti&oacute;n institucional de la Direcci&oacute;n.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Canalizar la respuesta a solicitudes, reclamos y sugerencias realizadas por la ciudadan&iacute;a, que sean dirigidas a la Direcci&oacute;n.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Elaborar proyectos que respondan a objetivos estrat&eacute;gicos de la Direcci&oacute;n, y que requieran financiamiento externo, estableciendo para ello coordinaci&oacute;n con los distintos jefes de Departamento de la Direcci&oacute;n.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Coordinar y gestionar acciones con otras instituciones p&uacute;blicas o privadas, con la finalidad de obtener informaci&oacute;n o asesor&iacute;a para presentar proyectos atingentes a los objetivos de la Direcci&oacute;n.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Gestionar los requerimientos de adquisiciones para la implementaci&oacute;n de actividades de las distintos Departamentos de la Direcci&oacute;n.</p>
    </li>
</ol>
<ol start="11">
    <li >
        <p >Cumplir con las dem&aacute;s funciones que le encomiende la Direcci&oacute;n, de acuerdo a la naturaleza de sus funciones y que est&eacute;n dentro del marco legal.&nbsp;</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1199",
      y: "516",
      width: "81",
      height: "50"
    },
    {
      id: "35",
      title: "DEPARTAMENTO DE DESARROLLO SOCIAL",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span size="3" >El Departamento de Desarrollo Social tiene como objetivo contribuir al mejoramiento de la calidad de vida de los habitantes de la comuna, centrando los esfuerzos y recursos hacia aquellas familias, y sectores en situaci&oacute;n de vulnerabilidad social, potenciando en ellos conductas proactivas y de autogesti&oacute;n en la soluci&oacute;n de problem&aacute;ticas individuales y familiares, incorpor&aacute;ndolos a la red social de prestaciones de gobierno y a los beneficios de origen municipal.&nbsp;</span></p>
<p ><span >Tendr&aacute; a su cargo la Secci&oacute;n Asistencial, Secci&oacute;n de An&aacute;lisis Social, Secci&oacute;n de Subsidios.</span></p>
<p ><span >Sus funciones espec&iacute;ficas son las siguientes:</span></p>
<ol>
    <li >
        <p >Elaborar diagn&oacute;sticos que permitan identificar, cuantificar y localizar los problemas socioecon&oacute;micos que afectan a la comunidad, manteniendo registros espec&iacute;ficos y actualizados.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Coordinar el desarrollo de acciones sociales con otras unidades municipales, con organismos del voluntariado e instituciones p&uacute;blicas y privadas.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Educar y orientar a la comunidad sobre los distintos beneficios de car&aacute;cter social disponibles y los requisitos exigidos para acceder a ellos.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Mantener una base de datos actualizada de instituciones y organismos que act&uacute;an en el &aacute;rea social de su competencia, de manera de realizar una adecuada coordinaci&oacute;n de redes en cada intervenci&oacute;n.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Elaborar y mantener actualizado registro de las atenciones y prestaciones proporcionadas, e informarlas a la Direcci&oacute;n con la periodicidad previamente, establecida.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Proporcionar atenci&oacute;n integral a las necesidades de los grupos familiares vulnerables.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Supervisar la ejecuci&oacute;n de convenios con otras entidades celebrados por el municipio para atender las necesidades sociales de la comuna.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Administrar los programas de cobertura nacional, colaborar en la elaboraci&oacute;n, desarrollo y evaluaci&oacute;n de proyectos y acciones destinadas a satisfacer las necesidades b&aacute;sicas que afecta a la poblaci&oacute;n de menores recursos en el marco del Plan de Desarrollo Comunal.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Coordinar los programas y/o convenios relacionados al &aacute;rea social, que se originen a causa de convenios suscritos entre el municipio y organismos de la administraci&oacute;n del Estado.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1288",
      y: "516",
      width: "81",
      height: "50"
    },
    {
      id: "36",
      title: "SECCIÓN ASISTENCIAL",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n Asistencial depende directamente del Departamento de Desarrollo Social y su objetivo es otorgar una atenci&oacute;n integral a las personas y/o familias, que presentan alguna carencia socioecon&oacute;mica o de necesidad manifiesta, con la finalidad de dar una soluci&oacute;n a las problem&aacute;ticas, realizando las gestiones ya sea a trav&eacute;s de una acci&oacute;n directa municipal o deriv&aacute;ndola a las redes de apoyo externos.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p >Prestar asistencia social en casos de estado de necesidad manifiesta calificados, que afecten a personas o grupos familiares o sectores de la poblaci&oacute;n.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Realizar entrevistas, visitas y todas las acciones necesarias tendientes a verificar las reales necesidades y condiciones de las familias.&nbsp;</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Elaborar diagn&oacute;sticos que permitan calificar la situaci&oacute;n econ&oacute;mica y social de los beneficiarios que demanden atenci&oacute;n, proporcionando a &eacute;stos, cuando cumplan con los requisitos, los beneficios que correspondan.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Establecer protocolos de coordinaci&oacute;n con redes de apoyo internos y externos al Municipio para la soluci&oacute;n de problemas de &iacute;ndole social.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Prestar atenci&oacute;n integral y llevar un registro de los casos sociales que se detecten en la comuna, el cual contenga los beneficios y diferentes tipos de ayuda entregadas a personas y grupos familiares atendidos.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Otorgar orientaci&oacute;n, asesor&iacute;a y apoyo emocional a los individuos y grupos familiares que presentan alguna problem&aacute;tica social, de manera que los usuarios tengan una participaci&oacute;n activa en la resoluci&oacute;n de &eacute;sta.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Mantener un registro de las personas y familias beneficiadas. Asimismo, de las prestaciones otorgadas, con el objeto de facilitar la fiscalizaci&oacute;n de las acciones realizadas, y la emisi&oacute;n de los informes que correspondan.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Prestar atenci&oacute;n inmediata frente a situaciones de emergencia comunal, que provoquen necesidad manifiesta; entregando la ayuda material necesaria, en coordinaci&oacute;n con otras unidades municipales y/o entidades vinculadas a emergencia.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Integrar, cuando proceda, el Comit&eacute; de Emergencia Municipal, seg&uacute;n las disposiciones establecidas en materia de Protecci&oacute;n Civil.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Cumplir con las dem&aacute;s funciones que le encomiende su jefatura, de acuerdo a la naturaleza de sus funciones y que est&eacute;n dentro del marco legal.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1287",
      y: "570",
      width: "81",
      height: "50"
    },
    {
      id: "37",
      title: "ANÁLISIS SOCIAL",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span size="3" >La Secci&oacute;n de An&aacute;lisis Social depende directamente del Departamento de Desarrollo Social, su objetivo es apoyar la postulaci&oacute;n y selecci&oacute;n de beneficiarios de las instituciones y organismos del Estado que otorgan prestaciones sociales a trav&eacute;s de un sistema construido con informaci&oacute;n aportada por el hogar y bases de datos disponibles.&nbsp;</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Brindar atenci&oacute;n a las personas que concurran a solicitar informaci&oacute;n respecto al procedimiento de evaluaci&oacute;n social vigente.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Realizar la aplicaci&oacute;n del instrumento de evaluaci&oacute;n social a las personas y grupos familiares solicitantes.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Proporcionar atenci&oacute;n a los usuarios/as para acceder al sistema, verificaci&oacute;n de antecedentes, y entrega de certificados.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Llevar a cabo las actualizaciones del sistema de evaluaci&oacute;n social en plataforma digital.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Preparar hoja de ruta y asignar domicilio a las encuestadoras.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Aplicar en terreno instrumento de medici&oacute;n en caso de cambio de domicilio o inscripci&oacute;n por primera vez.&nbsp;</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Supervisar trabajo desarrollado por encuestadoras/es y revisi&oacute;n de encuestas.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Digitar y validar la informaci&oacute;n en el Sistema de medici&oacute;n social vigente.&nbsp;</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Elaborar estad&iacute;sticas de informaci&oacute;n por unidades vecinales.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Mantener coordinaci&oacute;n permanente con el encargado regional del Sistema de medici&oacute;n social vigente.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1287",
      y: "623",
      width: "81",
      height: "50"
    },
    {
      id: "38",
      title: "SECCIÓN DE SUBSIDIOS",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n de Subsidios depende directamente del Departamento de Desarrollo Social, su objetivo es gestionar, atender y calificar a los postulantes de los diversos subsidios que otorga el Estado.</span></p>
<p ><span >Tiene las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p >Proporcionar atenci&oacute;n a las personas que soliciten informaci&oacute;n, respecto a los distintos subsidios que entrega el Estado.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Orientar y asesorar en materias de subsidios familiares, pensiones b&aacute;sicas solidarias, aportes previsionales solidarios, subsidios de agua potable, de gas y otros, que se encuentren vigentes.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Informar a las personas respecto de los requisitos y documentos que se necesitan para iniciar la postulaci&oacute;n correspondiente.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Calificar a los postulantes en conformidad a las disposiciones legales.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Preparar las resoluciones que determinan la calidad de causantes y beneficiarios de subsidios estatales.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Elaborar y enviar a la Intendencia, al Instituto de Previsi&oacute;n Social, a la Superintendencia de Seguridad Social u otros organismos del Estado, las estad&iacute;sticas mensuales de beneficiarios y postulantes en lista de espera, previa autorizaci&oacute;n del Alcalde.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1287",
      y: "675",
      width: "81",
      height: "50"
    },
    {
      id: "39",
      title: "DEPARTAMENTO DE DESARROLLO LOCAL COMUNITARIO",
      imagen: "",
      bajadaImagen: "",
      description: `

<p ><span >El Departamento de Desarrollo Local Comunitario tiene como objetivo implementar acciones tendientes a incentivar, potenciar y fortalecer la participaci&oacute;n de la comunidad organizada en las distintas esferas del desarrollo de la comuna ejecutando programas orientados a generar las condiciones m&iacute;nimas para la adecuada participaci&oacute;n de las organizaciones sociales y comunitarias.</span></p>
<p ><span >Tendr&aacute; a su cargo la Secci&oacute;n de Organizaciones Comunitarias, Secci&oacute;n de Deportes y Recreaci&oacute;n y Secci&oacute;n de Cultura y Actividades Comunales.</span></p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1375",
      y: "516",
      width: "81",
      height: "50"
    },
    {
      id: "40",
      title: "SECCIÓN DE ORGANIZACIONES COMUNITARAS",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n de Organizaciones Comunitarias depende del Departamento de Desarrollo Local Comunitario, cuyo objetivo es prestar asesor&iacute;a t&eacute;cnica a las organizaciones comunitarias, fomentar su desarrollo, legalizaci&oacute;n y promover su efectiva participaci&oacute;n en la comunidad.</span></p>
<p ><span >Tendr&aacute; como funciones:</span></p>
<ol>
    <li >
        <p >Asesorar a las organizaciones de la comunidad en todas aquellas materias que permitan facilitar su constituci&oacute;n y funcionamiento y la plena aplicaci&oacute;n de la Ley sobre Juntas de Vecinos y dem&aacute;s organizaciones comunitarias.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Detectar las organizaciones comunitarias existentes en la comuna incentivando su legalizaci&oacute;n e incorporaci&oacute;n a los programas desarrollados por la Direcci&oacute;n de Desarrollo Comunitario.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Asesorar a las organizaciones sociales en su proceso de postulaci&oacute;n a los distintos fondos concursables existentes, de modo de potenciar su gesti&oacute;n social.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Promover la formaci&oacute;n, funcionamiento y coordinaci&oacute;n de organizaciones territoriales y funcionales, prest&aacute;ndoles asesor&iacute;a t&eacute;cnica y capacitaci&oacute;n permanente.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Promover el acercamiento de los distintos servicios municipales en el territorio vecinal.&nbsp;</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Promover la participaci&oacute;n de las organizaciones comunitarias en el Consejo Comunal de Organizaciones de la Sociedad Civil.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Desarrollar los procedimientos t&eacute;cnicos para que las organizaciones comunitarias puedan acceder a los fondos concursables municipales vigentes.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Desarrollar programas de capacitaci&oacute;n con el objeto de que los dirigentes sociales logren alcanzar determinados objetivos, satisfacer necesidades, resolver problemas o desempe&ntilde;ar funciones sociales relevantes a nivel local.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Generar mecanismos, instrumentos y canales de comunicaci&oacute;n para incorporar a la comunidad organizada en el quehacer comunal.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Entregar apoyo e insumos para la realizaci&oacute;n de actividades sociales por parte de las organizaciones, de acuerdo a procedimientos establecidos y disponibilidad presupuestaria vigente.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1373",
      y: "571",
      width: "81",
      height: "50"
    },
    {
      id: "41",
      title: "SECCIÓN DE DEPORTES Y RECREACIÓN",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n de Deportes y Recreaci&oacute;n depende directamente del Departamento de Desarrollo Local y su objetivo es promover estilos de vida saludable, a trav&eacute;s de la ejecuci&oacute;n de actividades f&iacute;sicas y recreativas, implementadas para ni&ntilde;os, j&oacute;venes y adultos.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Procurar el desarrollo f&iacute;sico e intelectual de los habitantes de la comuna por medio del deporte y la recreaci&oacute;n.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Planificar y desarrollar programas para la participaci&oacute;n y realizaci&oacute;n de actividades deportivas y recreativas en la comuna.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Coordinar la participaci&oacute;n de otras entidades p&uacute;blicas o privadas para la realizaci&oacute;n de actividades deportivas y recreativas en la comuna.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Mantener canales de informaci&oacute;n y comunicaci&oacute;n eficientes que posibiliten la oportuna participaci&oacute;n de vecinos y de la comunidad en las actividades deportivas y recreativas que se programen.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Administrar o supervisar, seg&uacute;n corresponda, los recintos deportivos de la Municipalidad.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Proporcionar asesor&iacute;a t&eacute;cnico-deportiva a las distintas organizaciones sociales y comunitarias que as&iacute; lo requieran.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Otras funciones que la ley le asigne o que disponga la Direcci&oacute;n en conformidad a la legislaci&oacute;n vigente.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1373",
      y: "623",
      width: "81",
      height: "50"
    },
    {
      id: "42",
      title: "SECCIÓN DE CULTURA Y ACTIVIDADES COMUNALES",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span size="3" >La Secci&oacute;n de Cultura y&nbsp;Actividades Comunales&nbsp;</span><span >depende del Departamento de Desarrollo Local y su objetivo es promover la cultura, las artes y la realizaci&oacute;n de eventos dentro y fuera de la comuna.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Elaborar y ejecutar un Plan Cultural para la Municipalidad de Punta Arenas.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Fomentar la creaci&oacute;n, organizaci&oacute;n y atenci&oacute;n de Bibliotecas y Centros Culturales en la comuna.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Fomentar el conocimiento de los valores culturales de la comuna, dentro y fuera de ella y promover actividades tendientes a darle un car&aacute;cter propio.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Organizar y promover concursos y talleres literarios, pl&aacute;sticos, musicales y otros similares.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Montar exposiciones art&iacute;sticas y artesanales diversas, como expresi&oacute;n de la creaci&oacute;n cultural de los habitantes de la comuna.&nbsp;</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Organizar, patrocinar conciertos, recitales y espect&aacute;culos de arte, de promoci&oacute;n, difusi&oacute;n del folclore local y nacional.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Establecer contacto con otras instituciones que desarrollen actividades culturales, tanto a nivel comunal, como regional y nacional, con fines de intercambio.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Programar y ejecutar actividades y eventos orientados a promover la creaci&oacute;n art&iacute;stica, cient&iacute;fica y cultural de los habitantes de la comuna.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Administrar el Centro Cultural, Teatro Municipal, Bibliotecas Municipales, fomentando en la comunidad su utilizaci&oacute;n.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Coordinar, organizar, desarrollar las actividades culturales de la Municipalidad o patrocinadas por &eacute;sta.</p>
    </li>
</ol>
<ol start="11">
    <li >
        <p >Planificar, coordinar, organizar y ejecutar todos los eventos municipales o aquellos en los que se cuente con la participaci&oacute;n del Municipio.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1373",
      y: "675",
      width: "81",
      height: "50"
    },

    {
      id: "43",
      title: "DEPARTAMENTO DE SERVICIOS FOCALIZADOS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento: Sra. Carolina Barrientos Astorga</p>
<p ><span >El Departamento de Servicios Focalizados, tendr&aacute; como objetivo la implementaci&oacute;n de acciones en conjunto con la comunidad local, municipal y organismos p&uacute;blicos y privados, para dar respuesta a las necesidades e intereses espec&iacute;ficos que presenten ni&ntilde;os, j&oacute;venes y adultos.</span></p>
<p ><span >Estar&aacute;n a su cargo la Secci&oacute;n Municipal de la Mujer, Secci&oacute;n Comunal para personas en situaci&oacute;n de Discapacidad, la Secci&oacute;n Comunal del Adulto Mayor, la Secci&oacute;n Comunal de Infancia y Juventud, adem&aacute;s, la Secci&oacute;n Comunal de Migraci&oacute;n y Pueblos Originarios.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones generales:</span></p>
<ol>
    <li >
        <p >Orientar a personas y grupos de personas en diferentes materias sobre igual acceso de oportunidades e informaci&oacute;n de sus derechos y deberes ciudadanos; generando programas, si es posible, concordantes con sus necesidades.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Asesorar y apoyar t&eacute;cnicamente iniciativas y proyectos sociales que emprendan distintas personas o grupos de personas, dentro de las atribuciones propias de la Direcci&oacute;n.&nbsp;</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1462",
      y: "516",
      width: "81",
      height: "50"
    },
    {
      id: "44",
      title: "SECCIÓN OFICINA MUNICIPAL DE LA MUJER",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span size="3" >Esta secci&oacute;n depende del Departamento de Servicios Focalizados y su objetivo es generar las instancias de participaci&oacute;n e integraci&oacute;n de la mujer a la vida social y comunitaria, desarrollando las habilidades y competencias para su desarrollo integral.&nbsp;<br>&nbsp;</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Gestionar oportunidades de capacitaci&oacute;n para las mujeres.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Brindar informaci&oacute;n permanente a las mujeres sobre sus derechos y los servicios existentes en distintas instituciones.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Fomentar la participaci&oacute;n, la asociatividad, la conformaci&oacute;n de redes, el liderazgo y la toma de decisiones de las mujeres en los distintos espacios locales.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Promover la integraci&oacute;n de las mujeres al desarrollo de la comuna a trav&eacute;s de la informaci&oacute;n.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Crear espacios de participaci&oacute;n ciudadana y apoyar actividades y proyectos que surjan desde las propias mujeres organizadas.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Ejecutar convenios, programas y/o proyectos que se suscriban o adjudiquen en beneficio de las mujeres.&nbsp;</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1460",
      y: "571",
      width: "81",
      height: "50"
    },
    {
      id: "45",
      title: "SECCIÓN COMUNAL PARA PERSONAS EN SITUACIÓN DE DISCAPACIDAD",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n Comunal para personas en situaci&oacute;n de Discapacidad, depende del Departamento de Servicios Focalizados y su objetivo es promover el igual acceso de oportunidades para las personas, con el fin de obtener su real inclusi&oacute;n social.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Elaborar y mantener actualizado el diagn&oacute;stico comunal en materia de Discapacidad de sus habitantes.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Velar por la ejecuci&oacute;n de los programas y proyectos sobre materia Discapacidad, que emanen de convenios suscritos entre el municipio y otros organismos del Estado.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Efectuar an&aacute;lisis y evaluaciones permanentes de la ejecuci&oacute;n de los planes, programas y proyectos implementados en la comuna, en materia de Discapacidad.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Asesorar a las distintas organizaciones comunitarias en el dise&ntilde;o y elaboraci&oacute;n de proyectos y programas, en que favorezcan a personas en situaci&oacute;n de Discapacidad.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Realizar acciones de capacitaci&oacute;n a los dirigentes sociales que trabajan para y por las personas en situaci&oacute;n de Discapacidad.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Realizar acciones de difusi&oacute;n sobre discapacidades, con la finalidad de sensibilizar a la comunidad en esta materia y promover una mayor inclusi&oacute;n.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1460",
      y: "623",
      width: "81",
      height: "50"
    },
    {
      id: "46",
      title: "SECCIÓN COMUNAL DEL ADULTO MAYOR",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n Comunal del Adulto Mayor depende del Departamento de Servicios Focalizados y su objetivo es promover el aprendizaje acerca del envejecimiento y un mejor conocimiento de la conservaci&oacute;n de la calidad de vida en esta etapa.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Fortalecer el movimiento asociativo de los adultos mayores como forma de validaci&oacute;n para la expresi&oacute;n de sus necesidades.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Educar a la comunidad en torno al envejecimiento, como medio para lograr la valoraci&oacute;n de la vejez, como asimismo para que las futuras generaciones de adultos mayores vivan esta etapa de manera plena.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Generar y/o mantener estilos de vida saludable para desarrollar las condiciones f&iacute;sicas y mentales del adulto mayor.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Generar espacios intergeneracionales para sensibilizar a los j&oacute;venes respecto a la valoraci&oacute;n y respeto al adulto mayor.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Otorgar espacios de encuentro de los adultos mayores para incentivar su participaci&oacute;n en las actividades deportivas, sociales, recreativas y culturales.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1460",
      y: "675",
      width: "81",
      height: "50"
    },
    {
      id: "47",
      title: "SECCIÓN COMUNAL DE INFANCIA Y JUVENTUD",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n Comunal de Infancia y Juventud, depende del Departamento de Servicios Focalizados.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Dise&ntilde;ar e implementar una pol&iacute;tica local para la infancia, enfocado en su protecci&oacute;n y desarrollo integral.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Dise&ntilde;ar e implementar una pol&iacute;tica de juventud, enfocada en desarrollar y promover liderazgos sociales entre los j&oacute;venes de la comuna, aportando las herramientas necesarias para ello y que se traduzcan en un mejoramiento integral.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Desarrollar un diagn&oacute;stico participativo territorial de la infancia.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Elaborar estrategia comunicacional enfocada a la difusi&oacute;n y promoci&oacute;n de los derechos y deberes de los ni&ntilde;os y adolescentes.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Promover el desarrollo y promoci&oacute;n de la participaci&oacute;n y acci&oacute;n Juvenil en la comuna a trav&eacute;s de diversos encuentros juveniles de entretenci&oacute;n, &aacute;rea social y cultural entre otras.&nbsp;</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Fortalecer las habilidades sociales, personales y de liderazgo a trav&eacute;s de diferentes talleres por demanda espont&aacute;nea dirigido a los y las j&oacute;venes de la comuna.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Propender a la conformaci&oacute;n de grupos juveniles organizados.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1460",
      y: "728",
      width: "81",
      height: "50"
    },
    {
      id: "48",
      title: "SECCIÓN COMUNAL DE MIGRACIÓN Y PUEBLOS ORIGINARIOS",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >La Secci&oacute;n Comunal de Migraci&oacute;n y Pueblos Originarios, depende del Departamento de Servicios Focalizados, y su objetivo es promover y ejecutar una pol&iacute;tica de desarrollo local intercultural, que permita delinear acciones tendientes a potenciar el desarrollo de los habitantes de la comuna, respetando sus diferencias culturales.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p >Promover la asociatividad y constituci&oacute;n de asociaciones ind&iacute;genas, de acuerdo a la normativa vigente.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Difundir en la poblaci&oacute;n migrante e ind&iacute;gena, los beneficios sociales que se otorgan a trav&eacute;s del municipio u otros &oacute;rganos del Estado.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Construcci&oacute;n de un catastro y diagn&oacute;stico comunal respecto a las familias inmigrantes y descendientes de pueblos originarios que viven en la comuna.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Coordinar acciones con las instancias gubernamentales existentes, que dicen relaci&oacute;n con la tem&aacute;tica ind&iacute;gena y poblaci&oacute;n migrante.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Desarrollar actividades de fortalecimiento intercultural.</p>
    </li>
</ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1460",
      y: "780",
      width: "81",
      height: "50"
    },

    {
      id: "49",
      title: "DIRECCIÓN DE SEGURIDAD PÚBLICA",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Director: Sr. Carlos Raúl Sanhueza Schwarzenberg</p>
      <p ><span >La Direcci&oacute;n de Seguridad P&uacute;blica, ser&aacute; la encargada de coordinar y ejecutar acciones de prevenci&oacute;n y mitigaci&oacute;n de los distintos hechos provenientes de las personas, que puedan afectar la integridad ps&iacute;quica o f&iacute;sica de los vecinos, al verse expuestos a un peligro inminente o eventual.</span></p>
<p ><span >Para el ejercicio de sus funciones, podr&aacute; coordinarse con otros organismos del Estado que puedan contribuir al mejoramiento de la seguridad de las personas que viven o transitan en el territorio de la Comuna.</span></p>

<p ><span size="3" ><strong>ART&Iacute;CULO 42&ordm;:</strong></span><span > Asimismo, tendr&aacute; las siguientes atribuciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p >Crear, organizar y establecer planes de control para los programas que se encuentran bajo su supervigilancia y que contribuyan a la seguridad de los ciudadanos.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Elaborar y mantener actualizado el diagn&oacute;stico comunal en materia de Seguridad P&uacute;blica.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Elaborar, mantener actualizado y realizar el seguimiento del Plan Comunal de Seguridad P&uacute;blica.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Proponer al Alcalde planes de acci&oacute;n para enfrentar los hechos delictivos que ocurren en los distintos sectores de la Comuna.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Dar cumplimiento a los lineamientos y estrategias de Seguridad P&uacute;blica que emanen del Gobierno Central, especialmente en el diagn&oacute;stico de prevenci&oacute;n del delito.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Apoyar a Carabineros de Chile, en las acciones preventivas en materia de Seguridad P&uacute;blica y colaborar en su implementaci&oacute;n.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Realizar denuncias a la Polic&iacute;a de todos los hechos que puedan ser constitutivos de delitos y que puedan afectar la paz y seguridad social.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Crear y mantener un Registro actualizado de los hechos constitutivos de delitos que ocurran en la comuna. Este catastro deber&aacute; contener, al menos, las siguientes clasificaciones: tipo acci&oacute;n delictual, caracterizaci&oacute;n de sujeto activo si es posible su individualizaci&oacute;n, sector de la ciudad donde se cometi&oacute; la acci&oacute;n y fecha en que se realiz&oacute; la denuncia ante las autoridades si corresponde.&nbsp;</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Asesorar a los vecinos en la prevenci&oacute;n de los delitos.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Proporcionar al Alcalde y a las Direcciones que corresponda, cuando sea necesario, la informaci&oacute;n recogida por los m&oacute;viles de asistencia y seguridad vecinal.</p>
    </li>
</ol>
<ol start="11">
    <li >
        <p >Supervisar y controlar el adecuado mantenimiento de los veh&iacute;culos de seguridad que se pongan a disposici&oacute;n de la Direcci&oacute;n.</p>
    </li>
</ol>
<ol start="12">
    <li >
        <p >Crear y mantener un Catastro de las acciones en materia de seguridad, realizadas al servicio de las personas, que permitan efectuar un proceso de evaluaci&oacute;n y control.</p>
    </li>
</ol>
<ol start="13">
    <li >
        <p >Elaborar y ejecutar planes de seguridad con la finalidad de prevenir acciones delictivas, en coordinaci&oacute;n con Carabineros de Chile.&nbsp;</p>
    </li>
</ol>
<ol start="14">
    <li >
        <p >Velar por la ejecuci&oacute;n de los programas y proyectos sobre materias de Seguridad P&uacute;blica, que emanen de convenios suscritos entre el municipio y otros organismos del Estado.</p>
    </li>
</ol>
<ol start="15">
    <li >
        <p >Efectuar an&aacute;lisis y evaluaciones permanentes del desarrollo de los planes, programas y proyectos implementados en la comuna, en materia de Seguridad P&uacute;blica.</p>
    </li>
</ol>
<ol start="16">
    <li >
        <p >Llevar un registro de los proyectos de inversi&oacute;n comunal en ejecuci&oacute;n y por ejecutarse, en materia de Seguridad P&uacute;blica.</p>
    </li>
</ol>
<ol start="17">
    <li >
        <p >Cumplir otras funciones relacionadas con su cargo y que sean encomendadas por el Alcalde.</p>
    </li>
</ol>
<ol start="18">
    <li >
        <p >Efectuar labores de fiscalizaci&oacute;n, ante transgresiones a Ordenanzas y leyes de atingencia Municipal, detectadas en el cumplimiento de sus funciones, debiendo efectuar la correspondiente denuncia a los organismos competentes.</p>
    </li>
</ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1580",
      y: "443",
      width: "80",
      height: "48"
    },

    //     {
    //       id: "50",
    //       title: "DIRECCIÓN DE INSPECCIONES",
    //       imagen: "",
    //       bajadaImagen: "",
    //       description: `
    //       <p>Director: Sr. Sergio Oyarzo Álvarez</p>
    //       <p ><span >La Direcci&oacute;n de Inspecciones, ser&aacute; la encargada de controlar y fiscalizar el adecuado cumplimiento de las ordenanzas municipales vigentes en la comuna y de las disposiciones legales o reglamentarias de competencia municipal. Adicionalmente, deber&aacute; programar y dirigir las fiscalizaciones en terreno de la Municipalidad para la ejecuci&oacute;n de planes y programas institucionales.</span></p>
    // <p ><span >Tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
    // <ol>
    //     <li >
    //         <p >Elaborar en forma anual un Plan de Inspecci&oacute;n Comunal con programas espec&iacute;ficos de control, evaluando peri&oacute;dicamente, el cumplimiento de los planes establecidos.</p>
    //     </li>
    // </ol>
    // <ol start="2">
    //     <li >
    //         <p >Cursar infracciones por incumplimiento a las Ordenanzas Municipales u otras irregularidades detectadas en la inspecci&oacute;n y denunciarlas a los Juzgados de Polic&iacute;a Local correspondientes.</p>
    //     </li>
    // </ol>
    // <ol start="3">
    //     <li >
    //         <p >Atender las denuncias en terreno y preparar respuestas a aquellos reclamos recibidos de la comunidad en materias de competencia municipal.</p>
    //     </li>
    // </ol>
    // <ol start="4">
    //     <li >
    //         <p >Informar respecto de todas las irregularidades observadas en la v&iacute;a p&uacute;blica relativas a trabajos ejecutados por instituciones p&uacute;blicas o privadas.</p>
    //     </li>
    // </ol>
    // <ol start="5">
    //     <li >
    //         <p >Informar sobre las materias relacionadas con el comercio en las v&iacute;as p&uacute;blicas, avisos publicitarios, instalaciones de kioscos, veh&iacute;culos abandonados en espacios p&uacute;blicos u otros agentes que puedan afectar la seguridad y circulaci&oacute;n de veh&iacute;culos o peatones.&nbsp;</p>
    //     </li>
    // </ol>
    // <ol start="6">
    //     <li >
    //         <p >Efectuar notificaciones de diversas materias dentro del &aacute;mbito municipal, excluyendo aquellas que desde el punto de vista legal deban remitirse a trav&eacute;s de carta certificada.</p>
    //     </li>
    // </ol>
    // <ol start="7">
    //     <li >
    //         <p >Verificar en terreno el cumplimiento de requisitos para ejercer una actividad comercial.</p>
    //     </li>
    // </ol>
    // <ol start="8">
    //     <li >
    //         <p >Coordinar y efectuar fiscalizaciones en conjunto con Carabineros de Chile u otros Organismos que ejerzan labores fiscalizadoras.</p>
    //     </li>
    // </ol>
    // <ol start="9">
    //     <li >
    //         <p >Fiscalizar el cumplimiento de las disposiciones que regulan las concesiones y permisos municipales otorgados en bienes nacionales de uso p&uacute;blico.</p>
    //     </li>
    // </ol>
    // <ol start="10">
    //     <li >
    //         <p >Proponer la caducidad de las concesiones en los bienes de uso p&uacute;blico.</p>
    //     </li>
    // </ol>
    // <ol start="11">
    //     <li >
    //         <p >Informar al Alcalde de los incumplimientos de normas legales y reglamentarias que pudieran dar origen a la clausura, cierre o demolici&oacute;n de inmuebles de la comuna.</p>
    //     </li>
    // </ol>
    // <ol start="12">
    //     <li >
    //         <p >Administrar el corral municipal, manteniendo el registro y custodia de los veh&iacute;culos y sus partes, que ingresen a este recinto; informando al Alcalde sobre la cantidad y estado de los que se mantienen a su cargo.</p>
    //     </li>
    // </ol>
    // <ol start="13">
    //     <li >
    //         <p >Llevar estad&iacute;sticas actualizadas de todas las materias de su competencia e informarlas peri&oacute;dicamente a la SECPLAN.</p>
    //     </li>
    // </ol>
    // <ol start="14">
    //     <li >
    //         <p >Realizar otras funciones que le asigne el Alcalde en conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la Ley prescribe para otras unidades municipales.</p>
    //     </li>
    // </ol>
    //       `,
    //       popUp: true,
    //       link: "",
    //       target: "_blank",
    //       x: "1642",
    //       y: "443",
    //       width: "80",
    //       height: "48"
    //     },

    {
      id: "51",
      title: "DIRECCIÓN DE GESTIÓN DE  PERSONAS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Directora: Sr. Marcelo Velásquez</p>
      <p ><span size="3" ><span lang="es-CL">Tendr&aacute;&nbsp;</span></span><span >como objetivo fundamental administrar en forma eficiente los recursos humanos de la organizaci&oacute;n en todo el ciclo de la vida laboral, armonizando la expertis, capacidades y habilidades del personal con las necesidades de la Instituci&oacute;n.</span></p>
<p ><span lang="es-CL" >La Direcci&oacute;n de Gesti&oacute;n de Personas tendr&aacute; las siguientes funciones generales:</span></p>
<ol>
    <li >
        <p >Asesorar al Alcalde en materias de administraci&oacute;n del personal de la Municipalidad.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Verificar el cumplimiento de la Pol&iacute;tica de Recursos Humanos de la Municipalidad.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Realizar otras funciones que le asigne el Alcalde de conformidad con la legislaci&oacute;n vigente.</p>
    </li>
</ol>
<p ><span size="3" ><span lang="es-CL"><strong>ARTICULO 45&deg;:</strong></span><span lang="es-CL">&nbsp;</span>Para el cumplimiento de sus fines, la Direcci&oacute;n de Gesti&oacute;n de Personas, contar&aacute; con la el Departamento de Remuneraciones y la Secci&oacute;n de Personal.&nbsp;</span></p>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1732",
      y: "443",
      width: "80",
      height: "48"
    },

    {
      id: "52",
      title: "DEPARTAMENTO DE REMUNERACIONES",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento Sra. Erika Polanco Mancilla</p>

<p ><span >Tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p>Efectuar el c&aacute;lculo y pago de las remuneraciones, obligaciones previsionales y tributarias y otras obligaciones de los funcionarios de la Municipalidad, manteniendo los registros correspondientes.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p>Efectuar el c&aacute;lculo y pago de remuneraciones y obligaciones tributarias de las personas contratadas sobre la base de honorarios. </p>
    </li>
</ol>
<ol start="3">
    <li >
        <p>Registrar, tramitar y controlar las p&oacute;lizas de fidelidad, asignaciones de caja y de movilizaci&oacute;n.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p>Tramitar las licencias m&eacute;dicas y llevar un registro y control de rembolsos de licencias m&eacute;dicas.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p>Efectuar las declaraciones anuales de renta y entregar los certificados de renta anual.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p>Remitir a la Secci&oacute;nde Personal, detalle de horas por trabajos extraordinarios&nbsp;compensados con descanso complementario.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p>Proponer el presupuesto anual de gastos en personal, conforme a las limitaciones legales.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p>Verificar la disponibilidad presupuestaria en la ejecuci&oacute;n del gasto en personal.&nbsp;</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p>Elaborar Informes para Transparencia, SUBDERE y otros organismos.</p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1732",
      y: "497",
      width: "80",
      height: "48"
    },

    {
      id: "53",
      title: "SECCIÓN DE PERSONAL",
      imagen: "",
      bajadaImagen: "",
      description: `
<p ><span >Tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p >Efectuar el proceso administrativo de los nombramientos, contrataciones, renuncias, cese de funciones, destituciones, subrogancias, suplencias, destinaciones, permisos, feriados legales, licencias m&eacute;dicas y toda otra materia relacionada con el personal municipal.&nbsp;</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p>Mantener registros actualizados del personal municipal y emitir los certificados que le soliciten. </p>
    </li>
</ol>
<ol start="3">
    <li >
        <p>Gestionar el proceso de calificaciones del personal.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p>Preparar y actualizar el escalaf&oacute;n de m&eacute;ritos de los funcionarios municipales.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p>Elaborar las bases para los llamados a concursos p&uacute;blicos y gestionar el proceso hasta su total resoluci&oacute;n.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p>Llevar el registro de cargas familiares y de los beneficios relacionados.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p>Supervisar el cumplimiento de contratos y convenios relacionados con salas cunas, jardines infantiles y otros relacionados con el personal.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p>Planificar, coordinar, proponer, desarrollar y evaluar el Plan de Capacitaci&oacute;n dirigido a los funcionarios municipal y&nbsp;tramitar todas las capacitaciones autorizadas para el personal municipal.&nbsp;</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p>Efectuar controles peri&oacute;dicos de asistencia, de permanencia y de ejecuci&oacute;n de horas extraordinarias de los funcionarios municipales.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p>Disponer de manera oportuna y eficiente los recursos humanos necesarios para el desarrollo de las tareas municipales, teniendo en consideraci&oacute;n las normas estatutarias, pol&iacute;ticas, reglas vigentes e instrucciones sobre la materia.</p>
    </li>
</ol>
<ol start="11">
    <li >
        <p>Elaborar Informes para Transparencia, SUBDERE y otros organismos.</p>
    </li>
</ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1732",
      y: "550",
      width: "80",
      height: "48"
    },

    {
      id: "54",
      title: "DIRECCIÓN DE FOMENTO PRODUCTIVO Y TURISMO",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Director: Sra. Elizabeth Mansilla</p>
      <p ><span size="3" >La Direcci&oacute;n de Fomento Productivo y Turismo tiene las siguientes funciones y atribuciones:&nbsp;</span></p>
<ol>
    <li >
        <p >Proponer y ejecutar lineamientos tendientes a promover y materializar acciones relacionadas con el Fomento Productivo Local, Promoci&oacute;n Tur&iacute;stica y del Empleo en la comuna de Punta Arenas.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Administrar, planificar, ejecutar y controlar las actividades propias del Organismo T&eacute;cnico de Capacitaci&oacute;n (OTEC).&nbsp;</p>
    </li>
</ol>
<p ><span size="3" ><strong>ART&Iacute;CULO 46&ordm;:</strong>&nbsp;La Direcci&oacute;n de Fomento Productivo y Turismo tiene las siguientes funciones espec&iacute;ficas:&nbsp;</span></p>
<ol>
    <li >
        <p >Asesorar y apoyar t&eacute;cnicamente las iniciativas de proyectos de Fomento Productivo impulsadas por personas o agentes econ&oacute;micos de la comuna.</p>
    </li>
</ol>
<ol start="2">
    <li >
        <p >Crear y mantener un Registro de las actividades y empresas econ&oacute;micas existentes en la comuna.</p>
    </li>
</ol>
<ol start="3">
    <li >
        <p >Promover la capacitaci&oacute;n laboral en las empresas de la comuna.</p>
    </li>
</ol>
<ol start="4">
    <li >
        <p >Formalizar y potenciar alianzas estrat&eacute;gicas entre el sector p&uacute;blico, privado u otro para fomentar el desarrollo tur&iacute;stico.</p>
    </li>
</ol>
<ol start="5">
    <li >
        <p >Desarrollar acciones de promoci&oacute;n y difusi&oacute;n tur&iacute;stica de nuestra comuna.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p >Elaborar y mantener un Registro Comunal de Cesantes, con la finalidad de orientar a las personas en los tr&aacute;mites para obtener un Subsidio de Cesant&iacute;a.</p>
    </li>
</ol>
<ol start="7">
    <li >
        <p >Intermediar laboralmente con el sector privado la inserci&oacute;n laboral de los desocupados, inscritos en la OMIL.</p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >En general, mantener actualizado y dar cumplimiento a lo establecido en el Manual de Procedimiento de la OMIL.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Ejecutar directamente la administraci&oacute;n y gestionar a trav&eacute;s de terceros, la conservaci&oacute;n y reparaci&oacute;n del Mercado Municipal, Centro Artesanal, Paradero Mina Loreto y los m&oacute;dulos de administraci&oacute;n municipal ubicados en Costanera del Estrecho. Pudiendo tambi&eacute;n concesionarse la administraci&oacute;n de estos recintos.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Llevar estad&iacute;sticas actualizadas de todas las materias de su competencia e informarlas peri&oacute;dicamente a la SECPLAN.</p>
    </li>
</ol>
<ol start="11">
    <li >
        <p >Realizar otras funciones que le asigne el Alcalde de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la ley asigna a otras unidades.</p>
    </li>
</ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1822",
      y: "443",
      width: "80",
      height: "48"
    },

    {
      id: "55",
      title: "DIRECCIÓN DE SERVICIOS GENERALES",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Directora: Sra. Victoria Molkembuhr Sapunar</p>
      <p>La Dirección de Servicios Generales tendrá las siguientes funciones generales:</p>

<p>
</p>

<ol ><li><p>Administrar los servicios generales de la municipalidad, los que se entienden como el apoyo logístico de la institución, es decir, será la unidad encargada de permitir el adecuado funcionamiento de todas las unidades municipales.</p>

</li>
</ol><p>
</p>

<ol start="2" ><li><p>Velar por el correcto funcionamiento de las dependencias municipales desde la perspectiva de su operación material.</p>

</li>
</ol><p>
</p>

<ol start="3" ><li><p>Administrar la flota de transporte que comprende, los vehículos de uso municipal, sean propios o arrendados y controlar el uso racional del suministro de combustibles.</p>

</li>
</ol><p>
</p>

<ol start="4" ><li><p>Administrar el Sistema informático y de Comunicaciones municipales.</p>

</li>
</ol><p>

</p>

<ol start="5" ><li><p>Elaborar procedimientos de gestión interna, que faciliten el uso de servicios y recursos administrados a través de la Dirección.</p>

</li>
</ol>

<ol start="6" ><li><p>Asesorar y colaborar con el Alcalde y todas las unidades municipales, en aquellas materias relacionadas con el funcionamiento de los denominados servicios generales, definidos en el numeral 1 de este artículo.</p>

</li>
</ol><p>
</p>

<ol start="7" ><li><p>Mantener un registro estadístico actualizado de todas las materias de su competencia e informarlas a la SECPLAN.</p>

</li>
</ol><p>
</p>

<ol start="8" ><li><p>Realizar todas las otras funciones que le asigne el Alcalde, de conformidad con la legislación vigente y que no sean de aquellas que la ley asigna a otras unidades municipales.</p>

</li>
</ol><p>
</p>
<p><b>ARTÍCULO 48º:</b> Para el cumplimiento de sus funciones la Dirección de Servicios Generales, contará con el Departamento de Servicios, la Sección de Transporte; la Sección de Mantención de Muebles e Inmuebles de uso municipal y el Departamento de Informática y Sistemas de Comunicaciones.</p>

`,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1990",
      y: "444",
      width: "83",
      height: "48"
    },
    {
      id: "56",
      title: "DEPARTAMENTO DE SERVICIOS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento: Vacante</p>

<p>
</p>

<ol ><li><p>Tramitar el arrendamiento de inmuebles destinados al uso municipal y su correspondiente pago.</p>

</li>
</ol><p>
</p>

<ol start="2" ><li><p>Gestionar el término de contratos de arriendos y/o de comodatos de uso municipal, cuando corresponda.</p>

</li>
</ol><p>

</p>

<ol start="3" ><li><p>Asegurar la entrega de los suministros básicos destinados a las dependencias municipales y realizar análisis de gastos, proponiendo medidas de racionalización, si fuesen necesarias.</p>

</li>
</ol><p>

</p>

<ol start="4" ><li><p>Gestionar la contratación y administración de las pólizas de seguros destinados a los vehículos, equipos móviles, edificios municipales y sus contenidos de propiedad municipal.</p>

</li>
</ol><p>
</p>

<ol start="5" ><li><p>Gestionar, administrar y fiscalizar los contratos de suministros de servicios o prestaciones asociadas a inmuebles de uso municipal, tales como: Servicio de Seguridad, Servicio de Aseo, Servicio de Limpieza de Alfombras, Servicio de Control de Plagas, u otros que se estimen apropiados para la gestión municipal; potenciando condiciones propicias para os funcionarios y la comunidad en el uso de las dependencias municipales.</p>

</li>
</ol><p>
</p>

<ol start="6" ><li><p>Velar por la correcta administración y uso de los vehículos que componen la flota municipal.</p>

</li>
</ol><p>

</p>

<ol start="7" ><li><p>Controlar y supervisar el apropiado suministro y uso de combustibles, lubricantes; destinados al funcionamiento de los vehículos y equipos menores, que el municipio posea a cualquier título.</p>

</li>
</ol><p>

</p>

<ol start="8" ><li><p>Elaborar informes y estadísticas en materias propias de sus funciones.</p>

</li>
</ol><p>
</p>

<p>Dependerá del Departamento de Servicios, la Sección de Transportes.</p>

<p>
</p>

<p>
</p>


      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1900",
      y: "506",
      width: "85",
      height: "53"
    },
    {
      id: "57",
      title: "DEPARTAMENTO DE TRANSPORTES",
      imagen: "",
      bajadaImagen: "",
      description: `

<p>
</p>

<ol ><li><p>Elaborar y mantener un registro de la flota municipal, como de los choferes autorizados para su conducción.</p>

</li>
</ol><p>
</p>

<ol start="2" ><li><p>Fiscalizar el contrato de la flota de vehículos de uso municipal, y entregar reportes periódicos a su superior jerárquico.</p>

</li>
</ol><p>

</p>

<ol start="3" ><li><p>Efectuar monitoreo de los GPS de los vehículos de uso municipal, generando informes estadísticos.</p>

</li>
</ol><p>

</p>

<ol start="4" ><li><p>Realizar revisión de bitácoras y documentación de vehículos de uso municipal, conforme a normativa vigente.</p>

</li>
</ol><p>

</p>

<ol start="5" ><li><p>Efectuar control y elaborar estadística periódica de uso de combustible, conforme a periodicidad establecida por su superior jerárquico.</p>

</li>
</ol><p>

</p>

<ol start="6" ><li><p>Realizar activación de pólizas de seguro, efectuando la oportuna tramitación de uso.</p>

</li>
</ol><p>
</p>

<p>
</p>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1904",
      y: "573",
      width: "81",
      height: "49"
    },
    {
      id: "58",
      title: "SECCIÓN MANTENCIÓN DE MUEBLES E INMUEBLES DE USO MUNICIPAL",
      imagen: "",
      bajadaImagen: "",
      description: `



<ol ><li><p>Elaborar e implementar un plan de mantención de todos los recintos municipales, orientado a la reparación y mejoramiento de las dependencias propias y en comodato, ya sea con personal propio o a través de servicios externalizados.</p>

</li>
</ol><p>
</p>

<ol start="2" ><li><p>Generar procedimientos para priorizar mantenciones, habilitación y reparación de recintos de uso municipal.</p>

</li>
</ol><p>
</p>

<ol start="3" ><li><p>Determinar la priorización de intervenciones de reparación, habilitación u otras, a realizar a los bienes muebles e inmuebles que la Municipalidad ocupe para el desarrollo de su labor.</p>

</li>
</ol><p>
</p>

<ol start="4" ><li><p>Realizar el mantenimiento preventivo y la reparación de los bienes inmuebles municipales y de aquellos que la Municipalidad haya recibido en comodato, conforme a priorización de intervenciones y disponibilidad de recursos presupuestarios.</p>

</li>
</ol><p>
</p>

<ol start="5" ><li><p>Realizar el mantenimiento preventivo y la reparación de los bienes muebles de uso municipal.</p>

</li>
</ol><p>

</p>

<ol start="6" ><li><p>Generar contratos de suministro para mantención de recintos en aspectos referido a gasfitería, electricidad, cerrajería, mantención de calderas, u otros que se estimen pertinentes.</p>

</li>
</ol><p>
</p>

<ol start="7" ><li><p>Controlar y supervisar los contratos de los servicios licitados, referidos a materias inherentes a la Dirección.</p>

</li>
</ol><p>
</p>

<ol start="8" ><li><p>Llevar registro de los bienes raíces que la municipalidad tenga a cualquier título, que se consideren como medio para la realización de sus funciones, específicamente respecto de su estado y de su mantención.</p>

</li>
</ol><p>
</p>

<ol start="9" ><li><p>Elaborar informes y estadísticas en materias propias de sus funciones.</p>

</li>
</ol><p>
</p>

<p>
</p>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1990",
      y: "508",
      width: "81",
      height: "49"
    },
    {
      id: "59",
      title: "DEPARTAMENTO DE INFORMÁTICA Y SISTEMAS DE COMUNICACIONES",
      imagen: "",
      bajadaImagen: "",
      description: `
<p>Jefe de departamento: Sr. Diego Simunovic  Oyarzún</p>
<ol ><li><p>Realizar la implementación material y técnica de las Unidades Municipales en el ámbito informático.</p>

</li>
</ol><p>
</p>

<ol start="2" ><li><p>Administrar, controlar y supervisar el uso de los sistemas de comunicaciones que mantiene la Municipalidad, tales como, fibra óptica, telefonía fija, móvil e internet.</p>

</li>
</ol>

<ol start="2" ><li><p>Velar por el funcionamiento, seguridad, confiabilidad y confidencialidad de los sistemas computacionales y de la información contenida en las bases de datos que dependen de la Municipalidad.</p>


</li>
</ol>

    
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "2074",
      y: "507",
      width: "81",
      height: "49"
    },
    {
      id: "60",
      title: "DIRECCIÓN DE TRÁNSITO Y TRANSPORTE PÚBLICOS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Director: Sr. Marcel Bermúdez Orellana</p>

      <p ><span >La Direcci&oacute;n de Tr&aacute;nsito y Transporte P&uacute;blicos tiene las siguientes funciones generales:</span></p>
<ol>
    <li >
        <p ><span >Otorgar y renovar licencias para conducir veh&iacute;culos y permisos de circulaci&oacute;n.</span></p>
    </li>
</ol>
<ol start="2">
    <li >
        <p ><span >Determinar el sentido de circulaci&oacute;n de veh&iacute;culos, en coordinaci&oacute;n con los organismos de la Administraci&oacute;n del Estado competentes;</span></p>
    </li>
</ol>
<ol start="3">
    <li >
        <p ><span >Se&ntilde;alizar adecuadamente las v&iacute;as p&uacute;blicas;</span></p>
    </li>
</ol>
<ol start="4">
    <li >
        <p ><span >Aprobar, observar o rechazar los informes de mitigaci&oacute;n de impacto vial o emitir opini&oacute;n sobre ellos, a petici&oacute;n de la Secretar&iacute;a Regional Ministerial de Transportes y Telecomunicaciones, conforme a lo dispuesto en la Ley General de Urbanismo y Construcciones, y</span></p>
    </li>
</ol>
<ol start="5">
    <li >
        <p ><span >En general, aplicar las normas generales sobre tr&aacute;nsito y transporte p&uacute;blicos en la comuna.</span></p>
    </li>
</ol>
<p ><span ><strong>ART&Iacute;CULO 30&ordm;:</strong>&nbsp;La Direcci&oacute;n de Tr&aacute;nsito y Transporte P&uacute;blicos, tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p ><span >Asesorar en materias de tr&aacute;nsito y transporte p&uacute;blicos a la autoridad comunal, al Concejo y unidades municipales que lo requieran.</span></p>
    </li>
</ol>
<ol start="2">
    <li >
        <p ><span >Dirigir, coordinar y supervisar a los Departamentos de su unidad en funciones y actividades que desarrollan.</span></p>
    </li>
</ol>
<ol start="3">
    <li >
        <p ><span >Velar por el buen uso de los veh&iacute;culos municipales que se encuentran a cargo de la Direcci&oacute;n, de acuerdo a la normativa vigente.</span></p>
    </li>
</ol>
<ol start="4">
    <li >
        <p ><span >Entregar informes t&eacute;cnicos y/o administrativos que solicitan los Tribunales de Justicia u otros organismos competentes.</span></p>
    </li>
</ol>
<ol start="5">
    <li >
        <p ><span >Entregar informaci&oacute;n a la Secretar&iacute;a Comunal de Planificaci&oacute;n para la elaboraci&oacute;n del Presupuesto Municipal.</span></p>
    </li>
</ol>
<ol start="6">
    <li >
        <p ><span >Informar a la Direcci&oacute;n de Obras de todos aquellos antecedentes que sean necesarios para la adecuada formaci&oacute;n del catastro municipal.</span></p>
    </li>
</ol>
<ol start="7">
    <li >
        <p ><span >Elaborar especificaciones t&eacute;cnicas que se relacionen con proyectos e inversiones en materias de su competencia.&nbsp;</span></p>
    </li>
</ol>
<ol start="8">
    <li >
        <p ><span >Generar y mantener actualizados los procedimientos administrativos de la Direcci&oacute;n y sus Departamentos.</span></p>
    </li>
</ol>
<ol start="9">
    <li >
        <p ><span >Proponer la creaci&oacute;n, actualizaci&oacute;n, y modificaci&oacute;n de las Ordenanzas y Reglamentos Municipales que norman las materias en el &aacute;mbito de su gesti&oacute;n.</span></p>
    </li>
</ol>
<ol start="10">
    <li >
        <p ><span >Aplicar y proponer modificaciones a convenios vigentes con otros organismos p&uacute;blicos o privados, referidos a materias de la Direcci&oacute;n.</span></p>
    </li>
</ol>
<ol start="11">
    <li >
        <p ><span >Fiscalizar el funcionamiento de las escuelas de conductores no profesionales.&nbsp;</span></p>
    </li>
</ol>
<ol start="12">
    <li >
        <p ><span >Supervisar, coordinar y proponer modificaciones a los sistemas inform&aacute;ticos, de datos y equipamientos, en actual uso en la Direcci&oacute;n&nbsp;</span></p>
    </li>
</ol>
<ol start="13">
    <li >
        <p ><span >Otorgar tarjetas de estacionamiento de residente, conforme a la normativa vigente.</span></p>
    </li>
    <li >
        <p><span >Controlar y mantener el correcto funcionamiento de sem&aacute;foros de la comuna.</span></p>
    </li>
</ol>
<ol start="15">
    <li >
        <p ><span >&nbsp;Estudiar e informar a los organismos pertinentes sobre las solicitudes de autorizaci&oacute;n de recorridos de locomoci&oacute;n colectiva, estacionamientos, terminales y otros que puedan afectar la circulaci&oacute;n de veh&iacute;culos o peatones.</span></p>
    </li>
</ol>
<ol start="16">
    <li >
        <p ><span >&nbsp;Preparar y proponer modificaciones a la red vial b&aacute;sica de la comuna.</span></p>
    </li>
</ol>
<ol start="17">
    <li >
        <p ><span >Emitir opini&oacute;n t&eacute;cnica, cuando sean requeridas, respecto a proyectos con los organismos correspondientes.</span></p>
    </li>
    <li >
        <p ><span >Mantener el registro, efectuar el cobro y emitir opini&oacute;n sobre estacionamientos reservados y de taxis.&nbsp;</span></p>
    </li>
</ol>
<ol start="19">
    <li >
        <p ><span >Mantener las se&ntilde;alizaciones de las v&iacute;as p&uacute;blicas.&nbsp;</span></p>
    </li>
</ol>
<ol start="20">
    <li >
        <p ><span >Aprobar, observar o rechazar los informes de mitigaci&oacute;n de impacto vial o emitir opini&oacute;n sobre ellos, a petici&oacute;n de la Secretar&iacute;a Regional Ministerial de Transportes y Telecomunicaciones, conforme a lo dispuesto en la Ley General de Urbanismo y Construcciones.&nbsp;&nbsp;</span></p>
    </li>
</ol>
<ol start="21">
    <li >
        <p ><span >Revisar y aprobar los planes de se&ntilde;alizaci&oacute;n transitoria y medidas de seguridad por trabajos en las v&iacute;as p&uacute;blicas.</span></p>
    </li>
</ol>
<ol start="22">
    <li >
        <p ><span >Realizar an&aacute;lisis de problemas de tr&aacute;nsito que se presentan en la comuna, con el objetivo de evaluar medidas de gesti&oacute;n de tr&aacute;nsito que sean recomendables de implementar para mejorar las condiciones de circulaci&oacute;n y seguridad vial, tanto para conductores como peatones.</span></p>
    </li>
</ol>
<ol start="23">
    <li >
        <p ><span >Analizar factibilidad t&eacute;cnica y justificaci&oacute;n para la instalaci&oacute;n de se&ntilde;ales, demarcaciones, sem&aacute;foros y otros dispositivos de tr&aacute;nsito, que sean necesarios de implementar, con el objeto de mejorar las condiciones de tr&aacute;nsito y seguridad vial.</span></p>
    </li>
</ol>
<ol start="24">
    <li >
        <p ><span >Proponer pol&iacute;ticas p&uacute;blicas en seguridad vial, tr&aacute;nsito y transporte.</span></p>
    </li>
</ol>
<ol start="25">
    <li >
        <p ><span >Llevar estad&iacute;sticas actualizadas de todas las materias de su competencia e&nbsp;<br>&nbsp;informarlas al organismo que las solicite.</span></p>
    </li>
</ol>
<ol start="26">
    <li >
        <p ><span >Realizar otras funciones que le asigne el Alcalde de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la ley asigna a otras unidades.</span></p>
    </li>
</ol>
<p ><span ><strong>ART&Iacute;CULO 31&deg;:</strong>&nbsp;Para el cumplimiento de sus fines, la Direcci&oacute;n de Tr&aacute;nsito y Transporte P&uacute;blicos, contar&aacute; con los siguientes Departamentos:</span></p>
<ol type="A">
    <li >
        <p ><span >&nbsp;Licencias de Conducir.</span></p>
    </li>
    <li >
        <p ><span >Permisos de Circulaci&oacute;n.</span></p>
    </li>
</ol>
<a target="_blank" href="https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=" >https://www.bcn.cl/leychile/navegar?idNorma=251693&amp;idVersion=</a>

<p class="q-pt-md">Funciones y Atribuciones que se describen en el Art. 26 Ley  N°18.695 Orgánica Constitucional de Municipalidades</p>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "2190",
      y: "443",
      width: "81",
      height: "49"
    },
    {
      id: "61",
      title: "DEPARTAMENTO DE LICENCIAS DE CONDUCIR",
      imagen: "",
      bajadaImagen: "",
      description: `
<p>Jefe de departamento: Sra. Valeria Hernández Delgado</p>
<p ><span >El Departamento de Licencias de Conducir depender&aacute; de la Direcci&oacute;n de Tr&aacute;nsito y Transporte P&uacute;blicos; y tendr&aacute; como funci&oacute;n aplicar los procedimientos establecidos para otorgar, controlar y renovar licencias de conducir de acuerdo a la normativa legal vigente.</span></p>
<p ><span >Tendr&aacute; las siguientes funciones:</span></p>
<ol>
    <li >
        <p ><span >Otorgar, renovar, suspender, cancelar y denegar licencias para conducir veh&iacute;culos e informar de ello al Registro Nacional de Conductores, dependiente del Registro Civil e Identificaci&oacute;n, conforme a la normativa vigente.</span></p>
    </li>
</ol>
<ol start="2">
    <li >
        <p ><span >Informar, a trav&eacute;s de la Direcci&oacute;n, al Ministerio de Transporte y Telecomunicaciones de las licencias profesionales denegadas.</span></p>
    </li>
</ol>
<ol start="3">
    <li >
        <p ><span >Solicitar certificado de antecedentes para los postulantes a conductores a trav&eacute;s del Servicio de Registro Civil e Identificaci&oacute;n.</span></p>
    </li>
</ol>
<ol start="4">
    <li >
        <p ><span >Confeccionar los giros de ingresos municipales correspondientes a materias de su competencia.</span></p>
    </li>
</ol>
<ol start="5">
    <li >
        <p ><span >Mantener actualizado el archivo y registro de licencias de conducir, e informar a los organismos competentes</span>.</p>
    </li>
</ol>
<ol start="6">
    <li >
        <p ><span >Enviar antecedentes de licencias de conducir solicitados por otras Municipalidades.</span></p>
    </li>
</ol>
<ol start="7">
    <li >
        <p ><span >Asesorar a la Direcci&oacute;n en el cobro de los derechos municipales y su aplicaci&oacute;n por concepto de licencias de conducir.</span></p>
    </li>
</ol>
<ol start="8">
    <li >
        <p >Supervisar la revisi&oacute;n de certificados, para la calificaci&oacute;n de la idoneidad moral de los postulantes.</p>
    </li>
</ol>
<ol start="9">
    <li >
        <p >Mantener actualizados los requerimientos de Registro Civil para efectos de control y pago de certificados emitidos.</p>
    </li>
</ol>
<ol start="10">
    <li >
        <p >Supervisar el archivo de carpetas de licencias para asignaci&oacute;n a los funcionarios responsables de los diferentes tr&aacute;mites.</p>
    </li>
</ol>
<ol start="11">
    <li >
        <p >Resguardar los formularios de Licencia de conducir y sus respectivos sellos.</p>
    </li>
</ol>
<ol start="12">
    <li >
        <p >Supervisar y coordinar el env&iacute;o de archivos digitales para la inscripci&oacute;n de licencias en el Registro Nacional de Conductores del Servicio de Registro Civil.</p>
    </li>
</ol>
<ol start="13">
    <li >
        <p ><span >Efectuar ex&aacute;menes psicot&eacute;cnicos, te&oacute;ricos y pr&aacute;cticos a quienes realizan tr&aacute;mites de licencias de conducir.</span></p>
    </li>
</ol>
<ol start="14">
    <li >
        <p ><span >Controlar los resultados de los ex&aacute;menes f&iacute;sicos, ps&iacute;quicos</span><span>,&nbsp;</span><span >te&oacute;ricos y pr&aacute;cticos del Gabinete T&eacute;cnico.</span></p>
    </li>
</ol>
<ol start="15">
    <li >
        <p >Verificar la idoneidad f&iacute;sica y ps&iacute;quica de los conductores para efectos de otorgamiento y renovaci&oacute;n de licencias de conducir</p>
    </li>
</ol>
<ol start="16">
    <li >
        <p >Supervisar a los funcionarios que cumplan roles de asistentes en la toma de ex&aacute;menes psicot&eacute;cnicos y sensom&eacute;tricos.</p>
    </li>
</ol>
<ol start="17">
    <li >
        <p >Supervisar plazos y acreditaciones de examinadores te&oacute;ricos y pr&aacute;cticos.</p>
    </li>
</ol>
<ol start="18">
    <li >
        <p >Supervisar el ingreso de informaci&oacute;n de aprobaci&oacute;n y reprobaci&oacute;n de ex&aacute;menes te&oacute;ricos y pr&aacute;cticos.</p>
    </li>
</ol>
<ol start="19">
    <li >
        <p >Revisar antecedentes para toma de ex&aacute;menes, horas m&eacute;dicas, solicitudes de certificados de antecedentes.</p>
    </li>
</ol>
<ol start="20">
    <li >
        <p >Controlar el cumplimiento de los plazos legales sobre la toma de ex&aacute;menes, psicot&eacute;cnicos, te&oacute;ricos y pr&aacute;cticos.</p>
    </li>
</ol>
<ol start="21">
    <li >
        <p >Controlar el ingreso de denegaciones por ex&aacute;menes te&oacute;ricos y/o pr&aacute;cticos en la plataforma de la Comisi&oacute;n Nacional de Seguridad de Tr&aacute;nsito.</p>
    </li>
</ol>
<ol start="22">
    <li >
        <p >Supervisar la entrega oportuna de solicitudes y/o listados de emisi&oacute;n de Certificados de Antecedentes para su emisi&oacute;n.</p>
    </li>
</ol>
<ol start="23">
    <li >
        <p ><span >Realizar permanentemente la revisi&oacute;n de procesos con el objeto de proponer cambios que sean necesarios para mejorar la gesti&oacute;n y atenci&oacute;n de nuestros usuarios.</span></p>
    </li>
</ol>
<ol start="24">
    <li >
        <p ><span >Asesorar a la Direcci&oacute;n en el cobro de los derechos municipales y su aplicaci&oacute;n por concepto de licencias de conducir.</span></p>
    </li>
</ol>
<ol start="25">
    <li >
        <p ><span >Proponer a la Direcci&oacute;n la creaci&oacute;n, actualizaci&oacute;n y modificaci&oacute;n de las Ordenanzas y Reglamentos Municipales que norman las materias en el &aacute;mbito de su gesti&oacute;n.</span></p>
    </li>
</ol>
<ol start="26">
    <li >
        <p ><span >Confeccionar los programas de actividades anuales de su Departamento.</span></p>
    </li>
</ol>
<ol start="27">
    <li >
        <p ><span >Apoyar a las distintas &aacute;reas de trabajo de acuerdo a las necesidades de servicio y conforme a requerimiento de la Direcci&oacute;n.</span></p>
    </li>
</ol>
<ol start="28">
    <li >
        <p ><span >Responder directamente o a trav&eacute;s de la Direcci&oacute;n todas las solicitudes en materias propias de su competencia.</span></p>
    </li>
</ol>
<ol start="29">
    <li >
        <p ><span >Mantener actualizada informaci&oacute;n estad&iacute;stica en materias de su competencia.</span></p>
    </li>
</ol>
<ol start="30">
    <li >
        <p ><span >Realizar otras funciones que le asigne la Direcci&oacute;n de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la ley asigna a otros Departamentos.</span></p>
    </li>
</ol>

      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "2135",
      y: "565",
      width: "81",
      height: "49"
    },
    {
      id: "62",
      title: "DEPARTAMENTO DE PERMISOS DE CIRCULACIÓN",
      imagen: "",
      bajadaImagen: "",
      description: `
    <p>Jefe de departamento: Sra. Soledad Águila Pérez</p>
<p ><span >&nbsp;Tendr&aacute; las siguientes funciones espec&iacute;ficas:</span></p>
<ol>
    <li >
        <p ><span >Otorgar y renovar los permisos de circulaci&oacute;n en consideraci&oacute;n con las normas de la Ley de Rentas Municipales, de Transito y otras pertinentes.</span></p>
    </li>
</ol>
<ol start="2">
    <li >
        <p ><span >Realizar todo el proceso administrativo relacionado con las solicitudes de renovaci&oacute;n de permisos de circulaci&oacute;n o la obtenci&oacute;n de ellos por primera vez, reemplazos de veh&iacute;culos de locomoci&oacute;n colectiva menor, cambios de datos y otorgamiento de duplicados, manteniendo el registro comunal y archivo respectivo.</span></p>
    </li>
</ol>
<ol start="3">
    <li >
        <p ><span >Verificar el cumplimiento de todos los requisitos legales y reglamentarios para la obtenci&oacute;n o renovaci&oacute;n de permisos de circulaci&oacute;n.&nbsp;</span></p>
    </li>
</ol>
<ol start="4">
    <li >
        <p ><span >Codificar y/o asimilar veh&iacute;culos, de acuerdo a tasaciones entregadas&nbsp;<s>a</s>&nbsp;por el Servicio de Impuestos Internos, en forma anual para el cobro del impuesto de permiso de circulaci&oacute;n.</span></p>
    </li>
</ol>
<ol start="5">
    <li >
        <p ><span >Verificar,&nbsp;los certificados de homologaciones, revisiones t&eacute;cnicas, an&aacute;lisis de gases de veh&iacute;culos y seguros obligatorios de accidentes personales (SOAP).</span></p>
    </li>
</ol>
<ol start="6">
    <li >
        <p ><span >Mantener el Registro Comunal de permisos de circulaci&oacute;n; el Registro de sellos catal&iacute;ticos, el Registro municipal de Carros y Remolques, y el Registro de los veh&iacute;culos fuera de circulaci&oacute;n.</span></p>
    </li>
</ol>
<ol start="7">
    <li >
        <p ><span >Confeccionar los giros de ingresos municipales correspondientes a materias de su competencia.&nbsp;</span></p>
    </li>
</ol>
<ol start="8">
    <li >
        <p ><span >Responder directamente o a trav&eacute;s de la Direcci&oacute;n todas las solicitudes en materias propias de su competencia.</span></p>
    </li>
</ol>
<ol start="9">
    <li >
        <p ><span >Apoyar a las distintas &aacute;reas de trabajo de acuerdo a las necesidades de servicio y conforme al requerimiento de la Direcci&oacute;n.</span></p>
    </li>
</ol>
<ol start="10">
    <li >
        <p ><span >Realizar permanentemente la revisi&oacute;n de procesos con el objeto de proponer cambios que sean necesarios para mejorar la gesti&oacute;n y atenci&oacute;n de nuestros usuarios.&nbsp;</span></p>
    </li>
</ol>
<ol start="11">
    <li >
        <p ><span >Proponer a la Direcci&oacute;n la creaci&oacute;n, actualizaci&oacute;n y modificaci&oacute;n de las Ordenanzas y Reglamentos Municipales que norman las materias en el &aacute;mbito de su gesti&oacute;n.</span></p>
    </li>
</ol>
<ol start="12">
    <li >
        <p ><span >Confeccionar los programas de actividades anuales de su Departamento.</span></p>
    </li>
</ol>
<ol start="13">
    <li >
        <p ><span >Coordinar con los dem&aacute;s Departamentos o Direcciones Municipales las acciones tendientes a la organizaci&oacute;n del proceso de renovaci&oacute;n de permisos de circulaci&oacute;n.&nbsp;</span></p>
    </li>
</ol>
<ol start="14">
    <li >
        <p ><span >Mantener actualizados los antecedentes de los permisos de circulaci&oacute;n de veh&iacute;culos en relaci&oacute;n con el Registro de Multas de Tr&aacute;nsito no pagadas.</span></p>
    </li>
</ol>
<ol start="15">
    <li >
        <p ><span >Mantener actualizada informaci&oacute;n estad&iacute;stica en materias de su competencia.</span></p>
    </li>
    <li >
        <p ><span >Realizar otras funciones que le asigne la Direcci&oacute;n de conformidad con la legislaci&oacute;n vigente y que no sea de aquellas que la ley asigna a otros Departamentos.</span></p>
    </li>
</ol>
      `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "2250",
      y: "565",
      width: "80",
      height: "49"
    },
    {
      id: "63",
      title:
        "DEPARTAMENTO DE REDUCCIÓN DEL RIESGO DE DESASTRES (RRD) Y EMERGENCIAS",
      imagen: "",
      bajadaImagen: "",
      description: `
      <p>Jefe de departamento Sr. Álvaro Guzmán Delgado</p>
       <ol> <p>1. Planificar, coordinar, realizar y supervisar acciones para prevenir y atender emergencias provenientes de desastres naturales o antr&oacute;picos&nbsp;</p> <p>2. Crear y mantener actualizado un Plano de Microzonificaci&oacute;n de Riesgo de la Comuna, el cual, podr&aacute; ser elaborado en conjunto con servicios p&uacute;blicos, privados, voluntariados y juntas de vecinos.</p> <p>3. Elaborar y mantener actualizado el Plan Comunal Para la Reducci&oacute;n del Riesgo y Desastre.</p> <p>4. Elaborar y mantener actualizado el Plan Comunal de Emergencia.</p> <p>5. Elaborar y ejecutar acciones para capacitar a los funcionarios municipales en los roles y funciones asignados en el Plan Comunal de Emergencia.</p> <p>6. Apoyar en la realizaci&oacute;n talleres en materia de REDUCCION DEL RIESGO DE DESASTRES impartidos por la Direcci&oacute;n.</p> <p>7. Mantener actualizadas las fichas de detecci&oacute;n de puntos cr&iacute;ticos y vulnerabilidad de la comuna, por amenazas detectadas antes fen&oacute;menos hidrometereol&oacute;gicos.</p> <p>8. Mantener actualizados los mapas de riesgos y de amenaza el cual deber&aacute; contar con el V&deg;B&deg; de la Ge&oacute;grafa del Municipio.&nbsp;</p> <p>9. Realizar an&aacute;lisis, diagn&oacute;sticos y evaluaciones permanentes del desarrollo de los planes, programas y proyectos implementados en la comuna, en materia de gesti&oacute;n de Reducci&oacute;n del Riesgo y Desastre.</p> <p>10. Preparar los antecedentes t&eacute;cnicos para las licitaciones municipales relacionadas con sus funciones, para lo cual, podr&aacute; solicitar cooperaci&oacute;n a otras direcciones del Municipio.</p> <p>11. Mantener actualizado el Plan de Enlace Comunal, Provincial y Regional.&nbsp;</p> <p>12. Ejecutar las acciones directas de coordinaci&oacute;n con instituciones p&uacute;blicas, privadas y del voluntariado, con el fin de dar un enfoque global de prevenci&oacute;n de emergencias y de la gesti&oacute;n de aquellas que se producen, con la finalidad de mitigar los eventos no deseados, actuando eficientemente en la fase de respuesta.</p> <p>13. Requerir personal id&oacute;neo o recursos materiales de las dem&aacute;s Direcciones, si es necesario, con la finalidad de realizar un levantamiento de informaci&oacute;n sobre da&ntilde;os provocados producto de un evento destructivo, reparaciones, mantenciones de bienes p&uacute;blicos y municipales, en caso de producirse una emergencia, desastre o cat&aacute;strofe.</p> <p>14. Asesorar en todas las materias y actividades relacionadas con las telecomunicaciones de emergencia dentro del &aacute;mbito municipal.</p> <p>15. Cumplir otras funciones emanadas de la jefatura.</p>  </ol>   `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1070",
      y: "505",
      width: "60",
      height: "38"
    },
    {
      id: "64",
      title: "DEPARTAMENTO DE OPERACIONES",
      imagen: "",
      bajadaImagen: "",
      description: ` <p>Jefe de departamento Sr. Víctor Soto Villegas</p>
      <ol>   <p>1. Organizar, disponer y dirigir el funcionamiento operativo de los camiones y maquinaria pesada de la Municipalidad.</p> <p>2. Programar, ejecutar y supervisar las reparaciones y mantenciones de camiones y maquinaria pesada municipal.&nbsp;</p> <p>3. Efectuar operativos especiales con el objeto de dar soluci&oacute;n a los requerimientos de la comunidad dentro del &aacute;mbito municipal. En el ejercicio de estas funciones, se deber&aacute; priorizar el apoyo de todas las personas damnificadas que sufran siniestros estructurales y otros, provocados por una emergencia en la Comuna.</p> <p>4. Denunciar ante la Direcci&oacute;n de Inspecciones o Seguridad Publica las infracciones a las normas legales o reglamentarias vigentes, en materias de su competencia.</p> <p>5. Elaborar y ejecutar planes y programas de mantenci&oacute;n de las v&iacute;as p&uacute;blicas urbanas no pavimentadas y caminos p&uacute;blicos de responsabilidad municipal, propuestos por la Direcci&oacute;n.&nbsp;</p> <p>6. Confeccionar y preparar los antecedentes t&eacute;cnicos para las licitaciones municipales relacionadas con sus funciones, para lo cual, podr&aacute; solicitar cooperaci&oacute;n a otras direcciones del Municipio.&nbsp;</p> <p>7. Despejar las v&iacute;as p&uacute;blicas que presenten acumulaci&oacute;n de nieve y escarcha priorizando las v&iacute;as estructurantes de la ciudad&nbsp;</p> <p>8. Planifica, coordinar y realizar la ejecuci&oacute;n de la limpieza peri&oacute;dica de lechos de r&iacute;os, canales, acequias, con la finalidad de prevenir y mitigar posibles desbordes.</p> <p>9. Apoyar log&iacute;sticamente las actividades recreativas y culturales, organizadas por la Municipalidad.</p> <p>10. Efectuar labores de mantenci&oacute;n, reparaci&oacute;n y reposici&oacute;n del mobiliario urbano de la comuna, ya sea por cuenta propia o a trav&eacute;s de terceros, mediante programas peri&oacute;dicos de ejecuci&oacute;n.&nbsp;</p> <p>11. Proveer de los elementos f&iacute;sicos necesarios que son de responsabilidad municipal para dar cumplimiento a las obligaciones de la Ley N&ordm; 18.700 Org&aacute;nica Constitucional sobre votaciones populares y escrutinios.&nbsp;</p> <p>12. Cumplir otras funciones emanadas de la jefatura.</p>    <ol>     `,
      popUp: true,
      link: "",
      target: "_blank",
      x: "1130",
      y: "505",
      width: "60",
      height: "38"
    }
  ];

  public openDialog(item) {
    if (item.popUp) {
      this.dialogInfo = item;
      this.showDialog = true;
    } else {
      window.open(item.link, item.target);
    }
  }

  public closeDialog() {
    this.showDialog = false;
    this.dialogInfo = {};
  }
}
